<template>
  <div class="send-medici-container">
    <!-- 顶部区域 -->
    <div class="send-medici-header">
		<i class="el-icon-xy" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #00aa00;color: #fff;"></i>
		<h4 style="margin-left: 12px;">西药房门诊发药</h4>
    </div>
    
    <!-- 主体区域 -->
    <div class="send-medici-main">
      <!-- 左侧区域 (20%宽度) -->
      <div class="send-medici-left">
        <!-- 左侧上部表单 -->
        <div class="left-form">
          <el-form label-position="left" size="small">
            <el-form-item label="药房名称">
              <el-select v-model="form.pharmacyName" placeholder="请选择药房">
                <el-option label="西药房" value="西药房"></el-option>
              </el-select>
            </el-form-item>
                  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">健康ID</span>
				  <el-input v-model="form.healthId" placeholder="请输入健康ID"></el-input>
				</div>
			  </el-form-item>
			  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">处方查找</span>
				  <el-input v-model="form.prescriptionSearch" placeholder="处方编号"></el-input>
				</div>
			  </el-form-item>
			  
			  <el-form-item>
				<div class="form-item-row">
				  <!-- <span class="form-label">患者姓名</span> -->
					<!-- <el-input v-model="form.name" placeholder="姓名/拼音简码" clearable></el-input> -->
					<el-button 
                      type="primary" 
                      size="small" 
                      style="margin-left: 10px; padding: 6px 8px;" 
                      :loading="loading" 
                      @click="getUserInfo"
                    >
                      <i class="el-icon-Ssearch">查询</i>
                    </el-button>
				</div>
			  </el-form-item>
			  
			  <el-form-item>
				<div class="form-item-row">
				  <span class="form-label">刷新时长</span>
				  <el-input 
                    v-model="form.refreshTime" 
                    placeholder="秒" 
                    style="width: 60px;"
                    :disabled="true"
                    value="5"
                  ></el-input>
				  <el-checkbox v-model="form.showBatch" style="margin-left: 10px;">显示药品批次</el-checkbox>
				</div>
			  </el-form-item>
			</el-form>
        </div>
        
        <!-- 左侧下部表格 -->
        <div class="left-table-container">
          <el-table
            :data="leftTableData"
            border
            style="width: 100%"
            :height="leftTableHeight"
			@row-dblclick="getDataValue"
            size="small"
            class="left-table"
          >
            <el-table-column type="index" label="行号" width="48"></el-table-column>
            <el-table-column prop="name" label="病人姓名" width="88"></el-table-column>
            <el-table-column prop="age" label="年龄" width="60"></el-table-column>
			<el-table-column prop="sex" sortable label="性别" width="80">
			  <template slot-scope="scope">
			    <span>
			      <i :class="scope.row.sex === 1? 'el-icon-male' : 'el-icon-female'" 
			          :style="{color: scope.row.sex === 1 ? '#409EFF' : '#F56C6C'}"></i>
			      {{ scope.row.sex === 1 ? '男' : '女' }}
			    </span>
			  </template>
			</el-table-column>
			<el-table-column prop="patientId" label="健康id" width="80"></el-table-column>
			<el-table-column prop="cardId" label="身份证号码" width="188"></el-table-column>
			<el-table-column prop="fullName" label="处方医生" width="100"></el-table-column>
			<el-table-column prop="state" label="状态">
				<template slot-scope="{ row }">
					<!-- 根据state显示不同的图标 -->
					<div class="stateValue" style="border-radius: 4px;background-color: #e2fff6;text-align: center;color: #004a00;">
						<i :class="statusIconMap[row.state]" :style="{ color: statusColorMap[row.state] }"></i>
						<span>{{ statusMap[row.state] || '未知状态' }}</span>
					</div>
				</template>
			</el-table-column>
            <el-table-column prop="remark" label="备注" width="80"></el-table-column>
          </el-table>
          
          <!-- 左侧分页 -->
          <div class="left-pagination">
            <el-pagination
              @size-change="handleLeftSizeChange"
              @current-change="handleLeftCurrentChange"
              :current-page="leftPageNum"
              :page-sizes="[8, 15, 30, 50]"
              :page-size="leftPageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="leftTotal"
              small
            />
          </div>
        </div>
      </div>
      
      <!-- 右侧区域 (80%宽度) -->
      <div class="send-medici-right">
        <!-- 右侧上部描述列表 -->
        <div class="right-descriptions">
          <el-descriptions 
            title="" 
            border 
            :column="5" 
            size="small"
            class="custom-descriptions"
          >
            <el-descriptions-item label="处方编号">
              <el-tag size="small">{{ rightForm.rxNo || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="病员姓名">
              <el-tag size="small">{{ rightForm.name || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="身份证号">
              <el-tag size="small">{{ rightForm.cardId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="性别">
              <el-tag size="small" :type="rightForm.sex === 1 ? 'primary' : 'danger'">
                {{ rightForm.sex === 1 ? '男' : '女' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="年龄">
              <el-tag size="small">{{ rightForm.age || 0 }}岁</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="健康ID">
              <el-tag size="small">{{ rightForm.patientId || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方科室">
              <el-tag size="small">{{ rightForm.deptName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方医生">
              <el-tag size="small">{{ rightForm.fullName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方金额">
              <el-tag size="small" type="danger">￥{{ formatCurrency(rightForm.saleAmt || 0) }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="处方类型">
              <el-tag size="small">{{ rightForm.rxName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="皮试处方">
              <el-tag size="small" :type="rightForm.skintstRx === 1 ? 'danger' : 'info'">
                {{ rightForm.skintstRx === 1 ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="代办人">
              <el-tag size="small">{{ rightForm.agnterName || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="代办人身份证">
              <el-tag size="small">{{ rightForm.agnterCretno || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="西医诊断">
              <el-tag size="small">{{ rightForm.westernDiagnos || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag 
                size="small" 
                :type="getStatusType(rightForm.state)"
              >
                {{ getStatusText(rightForm.state) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="其它信息">
              <el-tag size="small">{{ rightForm.otherInfo || '-' }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="备注" :span="3">
              <span class="remark-text">{{ rightForm.remark || '-' }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 右侧下部表格 -->
        <div class="right-table-container">
          <el-table
            ref="rightTable"
            :data="rightTableData"
            border
            style="width: 100%"
            :height="rightTableHeight"
            size="small"
            show-summary
            :summary-method="getSummaries"
            class="right-table"
          >
            <el-table-column type="index" label="行号" width="60"></el-table-column>
            <el-table-column prop="drugName" label="药品名称" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="drugSpec" label="药品规格" width="120" show-overflow-tooltip></el-table-column>
			<el-table-column prop="pacSpec" label="包装规格" width="120"></el-table-column>
            <el-table-column prop="dosform" label="剂型" width="100"></el-table-column>
            <el-table-column prop="cnt" label="数量" width="80" align="right">
              <template slot-scope="{ row }">
                {{ row.cnt || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="unt" label="单位" width="60"></el-table-column>
            <el-table-column prop="usageName" label="用法" width="120"></el-table-column>
            <el-table-column prop="frequency" label="频次" width="100"></el-table-column>
            <el-table-column prop="prdDays" label="天数" width="60" align="right">
              <template slot-scope="{ row }">
                {{ row.prdDays || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="saleAmt" label="金额" width="80" align="right">
              <template slot-scope="{ row }">
                {{ formatCurrency(row.saleAmt || 0) }}
              </template>
            </el-table-column>
            <el-table-column prop="manuLotnum" label="批号" width="100"></el-table-column>
            <el-table-column prop="expyDate" label="有效期" width="120">
              <template slot-scope="{ row }">
                {{ row.expyDate || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="prodentpName" label="生产厂家" width="150" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    
    <!-- 底部区域 (100%宽度) -->
    <!-- 底部按钮区域 -->
    <div class="send-medici-bottom">
      <div class="bottom-left">
        <el-button 
          :loading="buttonLoading.print" 
          type="warning" 
          size="small"
          :disabled="true"
        >
          打印
        </el-button>
        <el-checkbox 
          v-model="closeAfterPrint" 
          style="margin-left: 10px;"
          :disabled="true"
        >
          自动打印
        </el-checkbox>
      </div>
      <div class="bottom-right">
		  
		  <el-button 
		    :loading="buttonLoading.sendMedic" 
		    type="success" 
		    size="small" 
			icon="el-icon-quyaoput"
		    @click="sendMedic"
		  >
		    发药
		  </el-button>
		  
        <el-button 
          :loading="buttonLoading.callPatient" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          呼叫患者
        </el-button>
        <el-button 
          :loading="buttonLoading.skipNumber" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          一键过号
        </el-button>
        <el-button 
          :loading="buttonLoading.refund" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          许可退费
        </el-button>
        <el-button 
          :loading="buttonLoading.printPrescription" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          打印处方
        </el-button>
        <el-button 
          :loading="buttonLoading.batchDispense" 
          type="primary" 
          size="small"
          :disabled="true"
        >
          批量发药
        </el-button>
      </div>
    </div>
	
	<!-- 完成发药对话框 -->
	<el-dialog
	  :visible.sync="sendMedicineDialogVisible"
	  title="完成发药"
	  width="500px"
	  :before-close="handleSendMedicineClose"
	  class="send-medicine-dialog"
	  :close-on-click-modal="false"
	>
	  <div class="send-medicine-content">
	    <div class="info-item">
	      <span class="label">患者</span>
	      <span class="value">{{ sendMedicineData.patientName || '匿名患者' }}</span>
	    </div>
	    <div class="info-item">
	      <span class="label">诊断</span>
	      <span class="value">{{ sendMedicineData.diagnosis || '无诊断信息' }}</span>
	    </div>
	    <div class="info-item">
	      <span class="label">发药内容</span>
	      <div class="medicine-content">
	        <!-- 修改追溯码显示 -->
	        <el-link 
	          type="primary" 
	          @click="openTraceCodeDialog"
	          class="trace-code-link"
	          :disabled="!isBarRequired"
	        >
	          追溯码（{{ sendMedicineData.traceCodeCount || 0 }}）
	        </el-link>
	        <div class="medicine-type" @click="toggleMedicineList">
	          <span>中西成药（{{ sendMedicineData.medicineCount || 0 }}种）</span>
	          <i :class="showMedicineList ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-left: 8px;"></i>
	        </div>
	        
	        <!-- 药品列表部分 -->
	        <div 
	          class="medicine-list" 
	          :class="{ 'expanded': showMedicineList }"
	          :style="{ 'max-height': showMedicineList ? medicineListMaxHeight : '0' }"
	        >
	          <div 
	            class="medicine-item" 
	            v-for="(item, index) in westernMedicines" 
	            :key="index"
	          >
	            <span class="medicine-name" :style="{ 
	              color: item.isBar === 1 ? 
	                (item.traceCodeCollected ? '#67C23A' : '#F56C6C') 
	                : 'inherit' 
	            }">
	              {{ item.drugName }}
	            </span>
	            <el-tag type="info" size="mini" style="margin-left: 8px;">西药</el-tag>
	            <span v-if="item.isBar === 1" style="margin-left: 10px;">
	              <span v-if="item.traceCodeCollected" style="color: #67C23A">
	                已录入追溯码
	              </span>
	              <span v-else style="color: #F56C6C">
	                该药品已强制要求追溯码，请先录入再进行发药！
	              </span>
	            </span>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
	  
	  <!-- 完成发药对话框底部 -->
	  <template #footer>
	    <div class="dialog-footer">
	      <el-checkbox v-model="sendMedicineData.printTogether">打印药品明细清单</el-checkbox>
	      <div class="footer-buttons">
	        <el-button @click="sendMedicineDialogVisible = false">取消</el-button>
	        
	        <!-- 检查是否有强制追溯码药品 -->
	        <el-tooltip 
	          v-if="hasUncollectedMandatoryTrace && isBarRequired" 
	          :content="tooltipMessage" 
	          placement="top"
	        >
	          <span>
	            <el-button 
	              type="primary" 
	              :disabled="hasUncollectedMandatoryTrace && isBarRequired"
	              @click="confirmSendMedicine"
	            >
	              确定
	            </el-button>
	          </span>
	        </el-tooltip>
	        
	        <el-button 
	          v-else-if="!isBarRequired" 
	          type="primary" 
	          @click="confirmSendMedicine"
	        >
	          确定
	        </el-button>
	        
	        <el-button 
	          v-else-if="isBarRequired && sendMedicineData.traceCodeCount > 0" 
	          type="primary" 
	          @click="confirmSendMedicine"
	        >
	          确定
	        </el-button>
	        
	        <el-tooltip 
	          v-else-if="isBarRequired && sendMedicineData.traceCodeCount === 0" 
	          content="请先录入追溯码" 
	          placement="top"
	        >
	          <span>
	            <el-button 
	              type="primary" 
	              :disabled="true"
	            >
	              确定
	            </el-button>
	          </span>
	        </el-tooltip>
	      </div>
	    </div>
	  </template>
	</el-dialog>
	
	<!-- 追溯码采集对话框 -->
	<el-dialog
	  :title="traceCodeDialogTitle"
	  :visible.sync="traceCodeDialogVisible"
	  width="1200px"
	  top="2vh"
	  @close="handleTraceCodeClose"
	  append-to-body
	  class="trace-code-collect-dialog"
	  :close-on-click-modal="false"
	  :close-on-press-escape="false"
	  :show-close="true"
	  :before-close="handleTraceCodeBeforeClose"
	>
	    <div class="trace-code-dialog-content">
	      <!-- 重要提醒 -->
	      <div class="important-reminder">
	        <div class="reminder-header">
	          <i class="el-icon-warning-outline"></i>
	          <span>重要提醒</span>
	        </div>
	        <div class="reminder-content">
	          <p>1：药品追溯码必须从药品追溯码平台查询，请仔细核对信息</p>
	          <p>2：必须将追溯码与对应药品关联，否则无法完成发药</p>
	          <p>3：一个药品可以有多个追溯码</p>
	          <p>4：将对应药品的追溯码信息上传至"码上放心"平台</p>
	        </div>
	      </div>
	      
	      <!-- 扫描输入区域 -->
	      <div class="scan-input-area">
	        <el-input
	          v-model="scanInput"
	          placeholder="请输入或扫描药品追溯码"
	          clearable
	          @keyup.enter.native="handleScanTraceCode"
	          class="trace-code-input"
	          :disabled="traceCodeLoading"
	          size="medium"
	          style="margin-bottom: 10px;"
	        >
	          <template #prepend>
	            <span>追溯码：</span>
	          </template>
	          <template #append>
	            <el-button 
	              @click="handleScanTraceCode" 
	              :loading="traceCodeLoading"
	              icon="el-icon-Ssearch"
	              type="primary"
	              size="medium"
	            >
	              查询
	            </el-button>
	          </template>
	        </el-input>
	        <div class="input-tips">
	          <span><i class="el-icon-info"></i> 支持扫码枪扫码</span>
	          <span><i class="el-icon-info"></i> 支持手动输入</span>
	          <span><i class="el-icon-info"></i> 支持多个追溯码</span>
	        </div>
	      </div>
	      
	      <!-- 药品验证结果提示 -->
	      <div v-if="getSomeWareResult" class="validation-result">
	        <el-alert
	          v-if="!getSomeWareResult.data || getSomeWareResult.data.length === 0"
	          title="当前追溯码的对应药品信息不存在于本系统中！"
	          type="warning"
	          :closable="true"
	          show-icon
	          @close="clearValidationResult"
	          style="margin-bottom: 10px;"
	        >
	          <div>
	            请仔细检查，如果确认追溯码无误，则您可以
	            <el-link 
	              type="primary" 
	              @click="goToDrugMaintenance"
	              style="margin: 0 5px; font-weight: bold;"
	            >
	              点击此处
	            </el-link>
	            ，去进行本系统的药品基本档案维护！
	          </div>
	        </el-alert>
	        <el-alert
	          v-else
	          title="药品已存在于本系统中，允许接入码上放心平台"
	          type="success"
	          :closable="true"
	          show-icon
	          @close="clearValidationResult"
	          style="margin-bottom: 10px;"
	        >
	          <div>药品验证通过，可以继续进行追溯码采集</div>
	        </el-alert>
	      </div>
	      
	      <!-- 已扫描的药品列表 -->
	      <div class="scanned-medicine-list-section" v-if="scannedMedicineList.length > 0">
	        <div class="section-header">
	          <h4>已扫描的药品信息：</h4>
	          <el-button
	            type="danger"
	            size="mini"
	            @click="clearAllScannedMedicines"
	            :disabled="scannedMedicineList.length === 0"
	            icon="el-icon-delete"
	          >
	            清空列表
	          </el-button>
	        </div>
	        
	        <el-table
	          :data="scannedMedicineList"
	          border
	          class="scanned-medicine-table"
	          height="400"
	          size="small"
	          style="width: 100%;"
	          ref="scannedMedicineTable"
	        >
	          <el-table-column type="index" label="序号" width="60" align="center" />
	          <el-table-column prop="traceCode" label="追溯码" width="200" show-overflow-tooltip />
	          <el-table-column prop="drugName" label="药品名称" min-width="200" show-overflow-tooltip />
	          <el-table-column prop="spec" label="规格" width="120" show-overflow-tooltip />
	          
	          <!-- 关键修改：包装数量列，支持编辑 -->
	          <el-table-column prop="pacCnt" label="包装数量" width="150" align="center">
	            <template #default="{ row }">
	              <template v-if="row.editable">
	                <!-- 可编辑状态：显示输入框 -->
	                <el-input
	                  v-model.number="row.pacCnt"
	                  type="number"
	                  :min="1"
	                  :max="row.originalPacCnt || 9999"
	                  size="mini"
	                  placeholder="请输入包装数量"
	                  @input="handlePacCntInput(row)"
	                  @blur="validatePacCnt(row)"
	                  :class="{ 'input-error': !row.pacCntValid }"
	                  style="width: 140px;"
	                >
	                  <template slot="append">个</template>
	                </el-input>
	                
	                <!-- 显示原始包装数量和校验提示 -->
	                <div v-if="row.originalPacCnt" style="margin-top: 4px; font-size: 12px; color: #909399;">
	                  原始包装数量: {{ row.originalPacCnt }}
	                </div>
	                <div v-if="!row.pacCntValid" style="color: #F56C6C; font-size: 12px; margin-top: 2px;">
	                  {{ row.pacCntError || '包装数量校验失败' }}
	                </div>
	              </template>
	              <template v-else>
	                <!-- 不可编辑状态：显示文本 -->
	                <span>{{ row.pacCnt || 1 }}</span>
	              </template>
	            </template>
	          </el-table-column>
	          
	          <el-table-column prop="manufacturer" label="生产厂家" min-width="200" show-overflow-tooltip />
	          <el-table-column prop="batchNo" label="生产批号" width="120" show-overflow-tooltip />
	          <el-table-column prop="produceDate" label="生产日期" width="100" />
	          <el-table-column prop="expireDate" label="有效期" width="100" />
	          
	          <!-- 销售单位列 -->
	          <el-table-column label="销售单位" width="100" align="center">
	            <template #default="{ row }">
	              <el-tag
	                v-if="row.saleUnt === 1"
	                type="warning"
	                size="mini"
	              >
	                最小单位
	              </el-tag>
	              <el-tag
	                v-else
	                type="info"
	                size="mini"
	              >
	                包装单位
	              </el-tag>
	            </template>
	          </el-table-column>
	          
	          <!-- 编辑状态列 -->
	          <el-table-column label="编辑状态" width="100" align="center">
	            <template #default="{ row }">
	              <el-tag
	                v-if="row.editable"
	                type="warning"
	                size="mini"
	              >
	                可编辑
	              </el-tag>
	              <el-tag
	                v-else
	                type="info"
	                size="mini"
	              >
	                不可编辑
	              </el-tag>
	            </template>
	          </el-table-column>
	          
	          <el-table-column label="系统验证" width="120" fixed="right">
	            <template #default="{ row }">
	              <el-tag
	                v-if="row.validationStatus === 'success'"
	                type="success"
	                size="small"
	              >
	                验证通过
	              </el-tag>
	              <el-tag
	                v-else-if="row.validationStatus === 'warning'"
	                type="warning"
	                size="small"
	              >
	                需维护
	              </el-tag>
	              <el-tag
	                v-else-if="row.validationStatus === 'error'"
	                type="danger"
	                size="small"
	              >
	                验证失败
	              </el-tag>
	              <el-tag
	                v-else
	                type="info"
	                size="small"
	              >
	                未验证
	              </el-tag>
	            </template>
	          </el-table-column>
	          
	          <el-table-column label="操作" width="100" fixed="right">
	            <template #default="{ $index }">
	              <el-button
	                type="text"
	                size="small"
	                @click="removeScannedMedicine($index)"
	                style="color: #F56C6C;"
	                icon="el-icon-delete"
	              >
	                删除
	              </el-button>
	            </template>
	          </el-table-column>
	        </el-table>
	        
	        <div class="scanned-summary">
	          <span>已扫描药品：{{ scannedMedicineList.length }} 个</span>
	          <span style="margin-left: 20px;">已录入追溯码：{{ scannedTraceCodeCount }} 个</span>
	          <span v-if="hasInvalidPacCnt" style="margin-left: 20px; color: #F56C6C;">
	            存在包装数量校验不通过
	          </span>
	        </div>
	      </div>
	      
	      <!-- 当没有扫描药品时的提示 -->
	      <div v-else class="empty-scanned-list">
	        <div class="empty-content">
	          <i class="el-icon-s-management" style="font-size: 60px; color: #C0C4CC;"></i>
	          <p style="margin-top: 10px; color: #909399;">暂无已扫描的药品信息</p>
	          <p style="color: #C0C4CC; font-size: 12px;">请在输入框中输入或扫描追溯码</p>
	        </div>
	      </div>
	    </div>
	    
	    <!-- 修改追溯码采集对话框的确定按钮 -->
	    <template #footer>
	      <div class="trace-code-footer">
	        <el-button 
	          @click="handleTraceCodeClose" 
	          size="medium"
	          icon="el-icon-close"
	        >
	          关闭
	        </el-button>
	        <el-button 
	          type="primary" 
	          @click="completeTraceCode"
	          :disabled="scannedMedicineList.length === 0 || !allPacCntValid"
	          :loading="traceCodeLoading"
	          size="medium"
	          icon="el-icon-check"
	        >
	          确定
	        </el-button>
	      </div>
	    </template>
	  </el-dialog>
	  
	  <!-- 追溯码扫码录入弹框 -->
	    <el-dialog
	      :visible.sync="scanDialogVisible"
	      title="追溯码扫码录入"
	      width="600px"
	      class="scan-dialog"
	      :close-on-click-modal="false"
	    >
	      <div class="scan-container">
	        <div class="scan-header">
	          <i class="el-icon-camera"></i>
	          <span>请扫描药品追溯码</span>
	        </div>
	        
	        <div class="scan-preview">
	          <div class="scan-frame">
	            <div class="scan-line"></div>
	          </div>
	        </div>
	        
	        <div class="scan-input-area">
	          <el-input
	            v-model="scanInput"
	            placeholder="手动输入追溯码"
	            clearable
	            @keyup.enter.native="handleScanInput"
	          >
	            <template slot="append">
	              <el-button 
	                type="primary" 
	                @click="handleScanInput"
	                :disabled="!scanInput"
	              >
	                确认
	              </el-button>
	            </template>
	          </el-input>
	        </div>
	        
	        <div class="scan-tips">
	          <p><i class="el-icon-info"></i> 请将药品追溯码对准扫描框中心</p>
	          <p><i class="el-icon-info"></i> 扫码后请核对药品信息</p>
	        </div>
	        
	        <!-- 新增：匹配药品信息表格 -->
	        <div class="matched-medicines" v-if="matchedMedicines.length > 0">
	          <el-table
	            :data="matchedMedicines"
	            border
	            style="width: 100%; margin-top: 16px"
	            max-height="200"
	          >
	            <el-table-column prop="drugName" label="药品名称" width="150"></el-table-column>
	            <el-table-column prop="drugSpec" label="规格" width="120"></el-table-column>
	            <el-table-column label="追溯标识码">
	              <template slot-scope="scope">
	                {{ traceCodePrefix }}
	              </template>
	            </el-table-column>
	            <el-table-column label="完整追溯码" width="188">
	              <template slot-scope="scope">
	                {{ scanInput }}
	              </template>
	            </el-table-column>
	          </el-table>

	        </div>
	      </div>
	      
	      <div slot="footer" class="scan-footer">
	          <!-- 修改确认绑定按钮 -->
	          <el-button
	            type="primary" 
	            size="small"
	            @click="confirmTraceCode"
	            :disabled="matchedMedicines.length === 0"
	          >
	            确认绑定
	          </el-button>
	          <el-button size="small" @click="scanDialogVisible = false">取消</el-button>
	        </div>
	  </el-dialog>
	  <!-- 新增：发药进度条对话框 -->
	  <el-dialog
	    :visible.sync="progressDialogVisible"
	    title="发药进度"
	    width="600px"
	    :close-on-click-modal="false"
	    :close-on-press-escape="false"
	    :show-close="false"
	    class="progress-dialog"
	  >
	    <div class="progress-container">
	      <el-steps :active="progressStep" align-center>
	        <el-step title="检查追溯码" :description="progressStep1Desc"></el-step>
	        <el-step title="执行发药" :description="progressStep2Desc"></el-step>
	        <el-step title="上传医保" :description="progressStep3Desc"></el-step>
	      </el-steps>
	      
	      <div class="progress-details" v-if="progressDetails.length > 0">
	        <div class="details-title">执行详情：</div>
	        <div class="details-content">
	          <div v-for="(detail, index) in progressDetails" :key="index" class="detail-item">
	            <i :class="detail.type === 'success' ? 'el-icon-success success-icon' : 
	                       detail.type === 'error' ? 'el-icon-error error-icon' : 
	                       'el-icon-info info-icon'"></i>
	            <span>{{ detail.message }}</span>
	          </div>
	        </div>
	      </div>
	    </div>
	    
	    <!-- 进度条对话框的footer -->
	    <div slot="footer" class="progress-footer">
	      <el-button 
	        v-if="progressStep === 3 && !progressHasError" 
	        type="primary" 
	        @click="handleProgressComplete"
	      >
	        完成
	      </el-button>
	      <el-button 
	        v-if="progressHasError" 
	        type="danger" 
	        @click="progressDialogVisible = false"
	      >
	        关闭
	      </el-button>
	      <el-button 
	        v-if="progressStep < 3 && !progressHasError" 
	        :loading="progressLoading"
	        disabled
	      >
	        处理中...
	      </el-button>
	    </div>
	  </el-dialog>
	  
	  <!-- 步骤进度条模态框 -->
	  <el-dialog
	    :visible.sync="traceCodeUploadDialog"
	    title="追溯码上传进度"
	    width="600px"
	    :close-on-click-modal="false"
	    :close-on-press-escape="false"
	    :show-close="true"
	    class="trace-code-upload-dialog"
	    :before-close="handleProgressDialogBeforeClose"
	  >
	    <!-- 步骤条 -->
	    <div class="upload-steps">
	      <el-steps :active="traceCodeUploadStep" align-center>
	        <el-step
	          v-for="(step, index) in traceCodeUploadSteps"
	          :key="index"
	          :title="step.title"
	          :description="step.description"
	          :status="getStepStatus(index)"
	        />
	      </el-steps>
	    </div>
	    
	    <!-- 步骤详情 -->
	    <div class="upload-details" v-if="traceCodeUploadDetails.length > 0">
	      <div class="details-title">执行详情：</div>
	      <div class="details-content">
	        <div
	          v-for="(detail, index) in traceCodeUploadDetails"
	          :key="index"
	          class="detail-item"
	          :class="detail.type"
	        >
	          <i
	            :class="{
	              'el-icon-success': detail.type === 'success',
	              'el-icon-error': detail.type === 'error',
	              'el-icon-info': detail.type === 'info',
	              'el-icon-warning': detail.type === 'warning'
	            }"
	          />
	          <span>{{ detail.message }}</span>
	        </div>
	      </div>
	    </div>
	    
	    <!-- 上传进度 -->
	    <div v-if="msfxUploading" class="upload-progress">
	      <el-progress
	        :percentage="uploadProgress"
	        :status="uploadStatus"
	        :stroke-width="8"
	        :text-inside="true"
	      />
	    </div>
	    
	    <template #footer>
	        <div class="upload-dialog-footer">
	          <!-- 第三步失败时显示重新补传按钮 -->
	          <div v-if="showRetryButton && traceCodeUploadStep === 2">
	            <el-button
	              @click="retryMsfxUpload"
	              type="primary"
	              :loading="msfxUploading"
	              icon="el-icon-refresh"
	            >
	              重新补传
	            </el-button>
	            <el-button @click="closeProgressDialog">关闭</el-button>
	          </div>
	          
	          <!-- 正常情况 -->
	          <div v-else>
	            <!-- 未完成时显示关闭按钮 -->
	            <el-button
	              v-if="traceCodeUploadStep < 4"
	              @click="handleUploadCancel"
	            >
	              取消
	            </el-button>
	            
	            <!-- 完成时显示完成按钮 -->
	            <el-button
	              v-else-if="traceCodeUploadStep === 4 && !traceCodeHasError"
	              @click="closeProgressDialog"
	              type="primary"
	            >
	              完成
	            </el-button>
	            
	            <!-- 有错误时显示关闭按钮 -->
	            <el-button
	              v-else-if="traceCodeHasError"
	              @click="closeProgressDialog"
	              type="danger"
	            >
	              关闭
	            </el-button>
	          </div>
	        </div>
	      </template>
	  </el-dialog>
	  
	  <!-- 系统提示模态框 -->
	  <el-dialog
	    :title="systemPromptTitle"
	    :visible.sync="systemPromptVisible"
	    width="80%"
	    :close-on-click-modal="false"
	    :close-on-press-escape="false"
	    :show-close="false"
	    class="system-prompt-dialog"
	  >
	    <!-- 系统提示文字 -->
	    <div class="system-prompt-message">
	      <p style="margin-bottom: 20px; color: #F56C6C; font-weight: bold;">
	        本次处方单据中发药药品【{{ systemPromptDrug?.drugName || '' }}】的销售单位为最小单位，需对发药数量进行重新录入！
	      </p>
	      <p style="margin-bottom: 20px; color: #606266;">
	        发药数量不能超过本次药品的包装数量（{{ systemPromptDrug?.pacCnt || 1 }}）。
	      </p>
	    </div>
	    
	    <!-- 药品信息表格 -->
	    <div class="system-prompt-table">
	      <el-table
	        :data="systemPromptData"
	        border
	        style="width: 100%"
	        size="small"
	      >
	        <el-table-column prop="traceCode" label="已录追溯码" width="150" align="center">
	          <template slot-scope="scope">
	            <span>{{ scope.row.traceCode }}</span>
	          </template>
	        </el-table-column>
	        
	        <el-table-column prop="drugName" label="药品名称" width="150" align="center">
	          <template slot-scope="scope">
	            <span>{{ scope.row.drugName }}</span>
	          </template>
	        </el-table-column>
	        
	        <el-table-column prop="spec" label="规格" width="120" align="center">
	          <template slot-scope="scope">
	            <span>{{ scope.row.spec }}</span>
	          </template>
	        </el-table-column>
	        
	        <el-table-column prop="cnt" label="发药数量" width="150" align="center">
	          <template slot-scope="scope">
	            <el-input
	              v-model="scope.row.cnt"
	              type="number"
	              :min="1"
	              :max="scope.row.pacCnt"
	              size="small"
	              placeholder="请输入发药数量"
	              @change="handleCntChange(scope.row)"
	              @blur="validateCntInput(scope.row)"
	              style="width: 100px;"
	            >
	              <template slot="append">单位</template>
	            </el-input>
	            <div v-if="scope.row.pacCnt" style="margin-top: 5px; font-size: 12px; color: #909399;">
	              包装数量: {{ scope.row.pacCnt }}
	            </div>
	          </template>
	        </el-table-column>
	        
	        <el-table-column prop="pacCnt" label="包装数量" width="100" align="center">
	          <template slot-scope="scope">
	            <span>{{ scope.row.pacCnt }}</span>
	          </template>
	        </el-table-column>
	        
	        <el-table-column prop="manufacturer" label="生产厂家" width="150" align="center">
	          <template slot-scope="scope">
	            <span>{{ scope.row.manufacturer }}</span>
	          </template>
	        </el-table-column>
	        
	        <el-table-column prop="batchNo" label="生产批次号" width="150" align="center">
	          <template slot-scope="scope">
	            <span>{{ scope.row.batchNo }}</span>
	          </template>
	        </el-table-column>
	      </el-table>
	    </div>
	    
	    <!-- 模态框底部按钮 -->
	    <div slot="footer" class="system-prompt-footer">
	      <el-button @click="cancelSystemPrompt">取消</el-button>
	      <el-button type="primary" @click="saveSystemPromptCnt">保存</el-button>
	    </div>
	  </el-dialog>
	  
  </div>
</template>

<script>
// 接口
import { selectPatientInfo,fySave } from "@/api/MedicenHouse/WesternGive.js";
// 新增：医保接口相关
// import {ybapi} from "/src/api/yb/ybApi.js"
import { getChs, addInfYB, getlyId } from "@/api/yb/yb-api.js"; // 古

import { 
  msfxCodeDetail, 
  msfxGetEntInfoList, 
  msfListUpoutDetail, 
  msfxUploadInoutBill, 
  msfxUploadRetail,
  getSomeWare,  // 新增：根据药品名称和包装数量检索接口
  getCJSomeWare  // 新增：根据批准文号和药品ID获取厂家信息接口
} from "@/api/systemCatalogue/Western.js";

import { 
  sendYbRequest, 
  buildYbRequest, 
  generateYbHeaders,
  getUserInfo as getYbUserInfo
} from "@/api/yb/ybApi.js";
import {addYbRquestData, getqdNo, toUploadLY ,changeYB} from "@/api/yb";
// others - tool
import dayjs from "dayjs";

import { toYb3505 } from "@/api/yb/yb-api.js";

export default {
  name: 'SendMedici',
  
	computed: {
	  // 检查是否有强制追溯码药品
	  isBarRequired: {
	    get() {
	      // 添加防御性检查
	      if (!this.rightTableData || !Array.isArray(this.rightTableData)) {
	        console.log('rightTableData不存在或不是数组，isBarRequired返回false');
	        return false;
	      }
	      
	      if (this.rightTableData.length === 0) {
	        console.log('rightTableData为空数组，isBarRequired返回false');
	        return false;
	      }
	      
	      const hasBarDrug = this.rightTableData.some(item => {
	        // 安全访问item
	        if (!item) return false;
	        return item.isBar === 1 || item.drugTracB === 1;
	      });
	      
	      console.log('是否存在强制追溯码药品:', hasBarDrug);
	      return hasBarDrug;
	    },
	    set(value) {
	      // 添加空setter避免警告
	      console.warn('isBarRequired计算属性不应被直接赋值');
	    }
	  },
	  
	  // 检查是否有未采集的强制追溯码药品
	  hasUncollectedMandatoryTrace: {
	    get() {
	      console.log('计算hasUncollectedMandatoryTrace:');
	      console.log('rightTableData:', this.rightTableData);
	      
	      if (!this.rightTableData || this.rightTableData.length === 0) {
	        console.log('无药品，返回false');
	        return false;
	      }
	      
	      // 查找强制追溯码药品
	      const mandatoryDrugs = this.rightTableData.filter(item => 
	        item && (item.isBar === 1 || item.drugTracB === 1)
	      );
	      
	      console.log('强制追溯码药品数量:', mandatoryDrugs.length);
	      console.log('强制追溯码药品详情:', mandatoryDrugs);
	      
	      if (mandatoryDrugs.length === 0) {
	        console.log('无强制追溯码药品，返回false');
	        return false;
	      }
	      
	      // 检查是否有强制追溯码药品未录入追溯码
	      const uncollected = mandatoryDrugs.some(item => {
	        const hasTraceCode = !!(item.drgTracCode && item.drgTracCode.trim() !== '');
	        console.log(`药品: ${item.drugName}, 强制追溯码: ${item.isBar === 1}, 追溯码: ${item.drgTracCode}, 已采集: ${hasTraceCode}`);
	        return !hasTraceCode;
	      });
	      
	      console.log('是否有未采集的强制追溯码药品:', uncollected);
	      return uncollected;
	    },
	    set(value) {
	      // 添加空setter避免警告
	      console.warn('hasUncollectedMandatoryTrace计算属性不应被直接赋值');
	    }
	  },
	  
	  // 工具提示信息
	  tooltipMessage: {
	    get() {
	      if (this.hasUncollectedMandatoryTrace) {
	        return '存在强制追溯码药品未采集，请先完成追溯码采集';
	      }
	      return '';
	    },
	    set(value) {
	      // 添加空setter避免警告
	      console.warn('tooltipMessage计算属性不应被直接赋值');
	    }
	  },
	  
	  // 检查是否有无效的包装数量
	  hasInvalidPacCnt: {
	    get() {
	      if (!this.scannedMedicineList || this.scannedMedicineList.length === 0) {
	        return false;
	      }
	      
	      // 检查所有可编辑的药品
	      const invalidItems = this.scannedMedicineList.filter(item => 
	        item.editable && !item.pacCntValid
	      );
	      
	      return invalidItems.length > 0;
	    },
	    set(value) {
	      // 添加空setter避免警告
	      console.warn('hasInvalidPacCnt计算属性不应被直接赋值');
	    }
	  },
	  
	  // 已扫描的追溯码数量
	  scannedTraceCodeCount: {
	    get() {
	      if (!this.scannedMedicineList || this.scannedMedicineList.length === 0) {
	        return 0;
	      }
	      
	      return this.scannedMedicineList.filter(item => 
	        item.traceCode && item.traceCode.trim() !== ''
	      ).length;
	    },
	    set(value) {
	      // 添加空setter避免警告
	      console.warn('scannedTraceCodeCount计算属性不应被直接赋值');
	    }
	  },
	  
	  // 检查所有包装数量是否有效
	  allPacCntValid: {
	    get() {
	      return this.checkAllPacCntValid();
	    },
	    set(value) {
	      // 添加空setter避免警告
	      console.warn('allPacCntValid计算属性不应被直接赋值');
	    }
	  },
	},
	
  data() {
    return {
		searchedValue:'', // 患者姓名
		patientId:'', // 健康ID
		rxNoValue:'', // 处方编码
		// 新增扫码对话框相关数据
		scanDialogVisible: false,
		scanInput: '',
		currentScanItem: null,
		// blean
		loading:false,
		sexOptions:[{id:1,label:'男',value:'男'},{id:2,label:'女',value:'女'}],
		YNOption:[{id:0,label:'否'},{id:1,label:'是'}],//库房
      form: {
        pharmacyName: '西药房',
        healthId: '',
        prescriptionSearch: '',
        name: '',
        refreshTime: '5', // 默认5秒
        showBatch: true
      },
	  medicineListMaxHeight: '200px', // 设置默认值
      // 左侧表格分页
      leftPageNum: 1,
      leftPageSize: 8,
      leftTotal: 0,
      
	  // 发药对话框相关数据
	sendMedicineDialogVisible: false,
	sendMedicineData: {
	  patientName: '',
	  diagnosis: '',
	  traceCodeCount: 0,
	  medicineCount: 0,
	  printTogether: false
	},
	dispenseSuccess: false, // 新增：记录发药是否成功
	autoCloseTimer: null, // 新增：自动关闭计时器
	// 新增：进度条相关数据
	progressDialogVisible: false,
	traceCodeDialogVisible: false,
	progressStep: 0,
	progressStep1Desc: '等待检查',
	progressStep2Desc: '等待执行',
	progressStep3Desc: '等待上传',
	progressDetails: [],
	progressLoading: false,
	progressHasError: false,
	
	// 追溯码对话框相关数据
	// 步骤执行控制
	step5Executed: false, // 步骤5是否已执行
	scannedMedicineList: [], // 已扫描的药品列表
	traceCodeLoading: false, // 追溯码查询加载状态
	getSomeWareLoading: false, // 药品验证加载状态
	getSomeWareResult: null, // 药品验证结果
	showAddDrugDialog: false, // 是否显示添加药品对话框
	selectedDrugInfo: null, // 选择的药品信息
	// 步骤进度条模态框相关
	traceCodeUploadDialog: false, // 上传进度对话框
	traceCodeUploadStep: 0, // 当前步骤
	traceCodeUploadSteps: [
	  { title: '检查追溯码', description: '正在检查是否有药品需要录入追溯码...' },
	  { title: '接入码上放心', description: '正在接入码上放心平台接口...' },
	  { title: '上传追溯码', description: '正在上传发药明细追溯码数据...' },
	  { title: '完成上传', description: '追溯码发药已上传至码上放心平台。' },
	  { title: '完成发药', description: '已完成发药。' }
	],
	traceCodeUploadDetails: [], // 步骤详情
	traceCodeHasError: false, // 是否有错误
	uploadRetryCount: 0, // 重试次数
	maxUploadRetry: 3, // 最大重试次数
	msfxUploading: false, // 码上放心上传中
	showRetryButton: false, // 是否显示重新补传按钮
	// 系统提示模态框相关数据
	systemPromptVisible: false,
	systemPromptTitle: '',
	systemPromptData: [],
	systemPromptDrug: null, // 当前处理的药品
	// 修改原有属性
	traceCodeTableData: [], // 初始为空数组
	  showMedicineList: false, // 是否显示药品列表
	  westernMedicines: [], // 西药列表
	  timer: null, // 5秒刷新定时器
	  buttonLoading: { // 各按钮的加载状态
		print: false,
		callPatient: false,
		skipNumber: false,
		refund: false,
		printPrescription: false,
		batchDispense: false,
		sendMedic: false
	  },
      rightForm: {
			"age": 0,
			"agnterCretno": "",
			"agnterName": "",
			"cardId": "",
			"deptName": "",
			"fullName": "",
			"westernDiagnos": "",
			"id": 0,
			"name": "",
			"patientId": 0,
			"remark": "",
			"rxName": "",
			"rxNo": 0,
			"saleAmt": 0,
			"sex": 0,
			"skintstRx": 0,
			"state": 0,
			"voList": [
				{
					"cnt": 0,
					"dosform": "",
					"drugId": 0,
					"drgTracCnt":"",
					"drugName": "",
					"drgTracCode": "",
					"drugSpec": "",
					"dugPurcId": 0,
					"expyDate": "",
					"frequency": "",
					"manuLotnum": "",
					"maxPurcPric": 0,
					"maxSalePric": 0,
					"minPurcPric": 0,
					"minSalePric": 0,
					"pacCnt": 0,
					"prdDays": 0,
					"prodentpName": "",
					"prodentpNameId": 0,
					"purcAmt": 0,
					"purcPric": 0,
					"purcType": "",
					"rdDetailsId": 0,
					"rxId": 0,
					"saleAmt": 0,
					"salePric": 0,
					"saleUnt": 0,
					"supplyCandidateId": 0,
					"unt": "",
					"usageName": "",
					"drugTracB":0,
					"drugTracMaxCnt":'',
					"drugTracMaxId":'',
					"drugTracMinId":'',
				}
			]
      },
      leftTableData: [],
	  detailsVo: [],
      rightTableData: [],
	  // props
	  statusMap: {
	  	0: '草稿',
	  	1: '已收费',
	  	2: '已配药',
	  	3: '已发药',
	  	4: '已退药'
	  },
	  statusIconMap: {
	  	0: 'el-icon-document',
	  	1: 'el-icon-top-left',
	  	2: 'el-icon-check',
	  	3: 'el-icon-bottom-right',
	  	4: 'el-icon-document-checked',
	  },
	  statusColorMap: {
	  	0: '#909399',
	  	1: '#67C23A',
	  	2: '#409EFF',
	  	3: '#E6A23C',
	  	4: '#F56C6C',
	  },
	  
	  // 新增属性
	  traceCodeDialogTitle: '追溯码采集', // 改为动态标题
	  scanButtonText: '扫描', // 扫描按钮文本
	  // 新增数据项
	  traceCodePrefix: '', // 追溯码前7位
	  matchedMedicines: [], // 匹配到的药品列表
      closeAfterPrint: true,
      leftTableHeight: 'calc(100vh - 200px)',
      rightTableHeight: 'calc(100vh - 350px)'
    }
  },
  mounted() {
	this.loadData();
    this.calculateTableHeights();
    window.addEventListener('resize', this.calculateTableHeights);
    
    // 启动5秒定时刷新
    //this.startAutoRefresh();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeights);
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startQueueDispensing(prescriptions) {
      if (!prescriptions || prescriptions.length === 0) return;

      this.isQueueMode = true;
      this.prescriptionQueue = prescriptions;
      this.currentQueueIndex = 0;

      console.log(`开始排队发药，共 ${prescriptions.length} 个处方`);

      // 处理第一个处方
      this.processNextInQueue();
    },

    // 处理队列中的下一个处方
    // 处理队列中的下一个处方
    processNextInQueue() {
      // 检查队列是否已完成
      if (this.currentQueueIndex >= this.prescriptionQueue.length) {
        console.log('所有处方处理完成');
        this.isQueueMode = false;
        this.$message.success('所有处方处理完成');
        return;
      }

      const prescription = this.prescriptionQueue[this.currentQueueIndex];
      console.log(`处理第 ${this.currentQueueIndex + 1} 个处方，共 ${this.prescriptionQueue.length} 个`);

      // 直接设置数据，不要用 this.setDispenseData
      this.rightForm = {
        patientId: prescription.patientData.patientId,
        name: prescription.patientData.name,
        icdName: prescription.patientData.icdName,
        id: prescription.patientData.id
      };

      // 设置药品信息
      this.rightTableData = prescription.medicineData.map(item => ({
        id:item.id,
        drugName: item.drugName,
        drugTracB: item.drugTracB || 0,
        drgTracCnt: item.drgTracCnt || 0,
        traceCodeCollected: item.traceCodeCollected || false,
        drgTracCode: item.drgTracCode || ''
      }));

      console.log('队列发药：数据已设置', this.rightForm, this.rightTableData);

      // 打开发药对话框
      this.sendMedicineData = {
        patientName: prescription.patientData.name,
        diagnosis: prescription.patientData.icdName,
        traceCodeCount: this.calculateTraceCodeCount(),
        medicineCount: this.calculateMedicineCount(),
        printTogether: false
      };

      this.showMedicineList = prescription.medicineData.some(item => item.drugTracB === 1);
      this.loadWesternMedicines();

      // 显示发药对话框
      this.sendMedicineDialogVisible = true;
    },

    // 修改原有的确认发药方法

    // 执行队列发药
    async executeQueueDispensing() {
      try {
        // 执行发药流程
        await this.startSendMedicineProcess();

        // 发药成功后处理下一个
        this.currentQueueIndex++;
        this.processNextInQueue();

      } catch (error) {
        console.error('发药失败，继续下一个:', error);
        // 即使失败也继续下一个
        this.currentQueueIndex++;
        this.processNextInQueue();
      }
    },

    handleSendMedicineCancel() {
      // 如果是排队模式，直接继续下一个
      if (this.isQueueMode) {
        console.log(`第 ${this.currentQueueIndex + 1} 个处方被取消，继续下一个`);
        this.sendMedicineDialogVisible = false;
        this.currentQueueIndex++;
        this.processNextInQueue();
      } else {
        // 原有单处方取消逻辑
        this.sendMedicineDialogVisible = false;
        this.refreshTableData();
      }
    },
	// 启动5秒自动刷新
    startAutoRefresh() {
      // 清除现有定时器
      if (this.timer) {
        clearInterval(this.timer);
      }
      
      // 设置5秒刷新
      this.timer = setInterval(() => {
        this.loadData();
      }, 120000);
    },
    
	async loadData(){
	  this.loading = true;
	  try {
	    let res = await selectPatientInfo({
	      name: this.searchedValue,
	      patientId: this.patientId,
	      rxNo: this.rxNoValue,
	      pageNum: this.leftPageNum,
	      pageSize: this.leftPageSize
	    });
	    
	    if(res.code === 200){
	      this.leftTableData = res.data.content || [];
	      this.leftTotal = res.data.totalSize || 0;
	      console.log('加载患者数据成功:', this.leftTableData);
	    } else {
	      this.leftTableData = [];
	      this.leftTotal = 0;
	      this.$message.error('加载患者数据失败: ' + (res.message || '未知错误'));
	    }
	  } catch (error) {
	    console.error('加载患者数据异常:', error);
	    this.leftTableData = [];
	    this.leftTotal = 0;
	    this.$message.error('加载患者数据异常: ' + error.message);
	  } finally {
	    this.loading = false;
	  }
	},
	
	  // 左侧分页大小改变
	  handleLeftSizeChange(val) {
	    this.leftPageSize = val;
	    this.leftPageNum = 1;
	    this.loadData();
	  },
	  
	  // 左侧当前页改变
	  handleLeftCurrentChange(val) {
	    this.leftPageNum = val;
	    this.loadData();
	  },
	  
	  // 刷新按钮查询条件
	  getUserInfo(){
		this.searchedValue = this.form.name; // 患者姓名
		this.patientId = this.form.healthId; // 健康id
		this.rxNoValue = this.form.rxNoValue; // 处方查找
		this.leftPageNum = 1; // 重置到第一页
		this.loadData();
	  },
	
	// 修改后的发药流程控制方法
	async startSendMedicineProcess() {
	  // 打开进度对话框
	  this.progressDialogVisible = true;
	  this.progressStep = 0;
	  this.progressStep1Desc = '等待检查';
	  this.progressStep2Desc = '等待执行';
	  this.progressStep3Desc = '等待上传';
	  this.progressDetails = [];
	  this.progressHasError = false;
	  this.progressLoading = true;
	  
	  try {
		// 第一步：验证数据完整性
		await this.validateSendDataPreCheck();
	    // 第二步：检查追溯码
	    await this.checkTraceCodes();
	    
	    // 第3步：执行发药
	    const sendResult = await this.executeMedicineDispensing();
	    
	    // 第三步：根据用户类型决定是否上传医保
	    if (sendResult.success) {
	      if (sendResult.isInsurance) {
	        // 医保用户：调用医保接口
	        await this.uploadToMedicalInsurance();
	      } else {
	        // 非医保用户：直接完成流程
	        await this.handleNonInsuranceUser();
	      }
	    } else {
	      // 发药失败处理
	      this.addProgressDetail('发药失败', 'error');
	      this.progressHasError = true;
	      
	      // 根据用户类型决定是否尝试上传医保
	      if (sendResult.isInsurance) {
	        this.addProgressDetail('但仍尝试上传医保信息', 'warning');
	        await this.uploadToMedicalInsurance();
	      } else {
	        await this.handleNonInsuranceUser();
	      }
	    }
	    
	  } catch (error) {
	    console.error('发药流程异常:', error);
	    this.addProgressDetail(`发药流程异常: ${error.message}`, 'error');
	    this.progressHasError = true;
	  } finally {
	    this.progressLoading = false;
	    
	    // 如果流程完成且没有错误，设置自动关闭
	    if (this.progressStep === 3 && !this.progressHasError) {
	      setTimeout(() => {
	        this.progressDialogVisible = false;
	        this.$message.success('发药流程已完成');
	      }, 2000);
	    }
	  }
	},
	
	// 查询追溯码
	async handleScanTraceCode() {
	  if (!this.scanInput || this.scanInput.trim() === '') {
	    this.$message.warning('请输入追溯码');
	    return;
	  }
	  
	  const traceCode = this.scanInput.trim();
	  console.log('开始查询追溯码:', traceCode);
	  
	  // 检查是否已存在相同追溯码
	  const existingTraceCode = this.scannedMedicineList.find(item => item.traceCode === traceCode);
	  if (existingTraceCode) {
	    this.$message.warning('该追溯码已存在，无需重复添加');
	    this.scanInput = '';
	    return;
	  }
	  
	  try {
	    this.traceCodeLoading = true;
	    this.getSomeWareResult = null;
	    
	    // 1. 调用msfxCodeDetail接口
	    const response = await msfxCodeDetail({
	      codes: traceCode
	    });
	    
	    console.log('msfxCodeDetail接口返回:', response);
	    
	    if (response && response.code === 200 && response.data && response.data.length > 0) {
	      const traceCodeData = response.data[0];
	      const drugInfo = traceCodeData.drugEntBaseDTO || {};
	      const entInfo = traceCodeData.pUserEntDTO || {};
	      const produceInfo = traceCodeData.codeProduceInfoDTO?.produceInfoList?.[0] || {};
	      
	      // 提取药品名称
	      const drugName = drugInfo.physicName || '';
	      
	      // 提取包装数量 - 从prepnSpec中提取数字
	      const prepnSpec = drugInfo.prepnSpec || '1';
	      const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
	      
	      // 提取生产批号
	      const batchNo = produceInfo.batchNo || '';
	      
	      console.log('提取的药品信息:', {
	        drugName,
	        pacCnt,
	        prepnSpec,
	        batchNo
	      });
	      
	      if (!drugName) {
	        this.$message.error('未从追溯码中提取到药品名称');
	        this.traceCodeLoading = false;
	        return;
	      }
	      
	      // 2. 调用getSomeWare接口验证药品
	      this.getSomeWareLoading = true;
	      const wareResponse = await getSomeWare({
	        drugName: drugName,
	        pacCnt: pacCnt
	      });
	      
	      console.log('getSomeWare接口返回:', wareResponse);
	      this.getSomeWareResult = wareResponse;
	      
	      if (wareResponse && wareResponse.code === 200 && wareResponse.data) {
	        // 药品存在于系统中
	        const drugData = wareResponse.data;
	        
	        console.log('getSomeWare接口返回的药品信息:', {
	          药品名称: drugData.drugName,
	          包装数量: drugData.pacCnt
	        });
	        
	        // 从rightTableData中查找对应药品的saleUnt
	        let saleUnt = 2; // 默认包装单位
	        if (this.rightTableData && this.rightTableData.length > 0) {
	          const matchedMedicine = this.rightTableData.find(item => 
	            item && item.drugName && drugName && 
	            (item.drugName.includes(drugName) || drugName.includes(item.drugName))
	          );
	          if (matchedMedicine) {
	            saleUnt = matchedMedicine.saleUnt || 2;
	          }
	        }
	        
	        const medicineData = {
	          traceCode: traceCode,
	          drugName: drugName,
	          spec: drugInfo.pkgSpecCrit || '',
	          pacCnt: pacCnt,
	          originalPacCnt: pacCnt,
	          manufacturer: entInfo.entName || '',
	          batchNo: batchNo,           // 新增：生产批号
	          produceDate: produceInfo.produceDateStr || '',
	          expireDate: produceInfo.originalExpireDate || '',
	          validationStatus: 'success',
	          rawData: traceCodeData,
	          wareData: drugData,
	          saleUnt: saleUnt,
	          editable: false,
	          pacCntValid: true,
	          pacCntError: ''
	        };
	        
	        // 如果销售单位为最小单位，弹出提示框并设置可编辑
	        if (saleUnt === 1) {
	          console.log('药品销售单位为最小单位，弹出提示框');
	          try {
	            await new Promise((resolve) => {
	              this.$alert(
	                `药品【${drugName}】的销售单位为最小单位，需要对包装数量进行重新录入！`,
	                '系统提示',
	                {
	                  confirmButtonText: '我已知晓',
	                  type: 'warning',
	                  callback: (action) => {
	                    if (action === 'confirm') {
	                      medicineData.editable = true;
	                    }
	                    resolve();
	                  }
	                }
	              );
	            });
	          } catch (error) {
	            console.log('提示框处理异常:', error);
	            medicineData.editable = true;
	          }
	        } else {
	          medicineData.editable = false;
	        }
	        
	        // 添加到已扫描列表
	        this.addToScannedList(medicineData);
	        this.scanInput = '';
	        this.$message.success('药品验证通过，已添加到列表');
	      } else {
	        // 药品不存在于系统中
	        let saleUnt = 2;
	        if (this.rightTableData && this.rightTableData.length > 0) {
	          const matchedMedicine = this.rightTableData.find(item => 
	            item && item.drugName && drugName && 
	            (item.drugName.includes(drugName) || drugName.includes(item.drugName))
	          );
	          if (matchedMedicine) {
	            saleUnt = matchedMedicine.saleUnt || 2;
	          }
	        }
	        
	        const medicineData = {
	          traceCode: traceCode,
	          drugName: drugName,
	          spec: drugInfo.pkgSpecCrit || '',
	          pacCnt: pacCnt,
	          originalPacCnt: pacCnt,
	          manufacturer: entInfo.entName || '',
	          batchNo: batchNo,           // 新增：生产批号
	          produceDate: produceInfo.produceDateStr || '',
	          expireDate: produceInfo.originalExpireDate || '',
	          validationStatus: 'warning',
	          rawData: traceCodeData,
	          saleUnt: saleUnt,
	          editable: false,
	          pacCntValid: true,
	          pacCntError: ''
	        };
	        
	        if (saleUnt === 1) {
	          try {
	            await new Promise((resolve) => {
	              this.$alert(
	                `药品【${drugName}】的销售单位为最小单位，需要对包装数量进行重新录入！`,
	                '系统提示',
	                {
	                  confirmButtonText: '我已知晓',
	                  type: 'warning',
	                  callback: (action) => {
	                    if (action === 'confirm') {
	                      medicineData.editable = true;
	                    }
	                    resolve();
	                  }
	                }
	              );
	            });
	          } catch (error) {
	            medicineData.editable = true;
	          }
	        }
	        
	        this.addToScannedList(medicineData);
	        this.$message.warning('药品不存在于本系统中，请先进行药品维护');
	      }
	    } else {
	      this.$message.error('未查询到该追溯码的信息');
	    }
	  } catch (error) {
	    console.error('查询追溯码失败:', error);
	    this.$message.error('查询追溯码失败: ' + error.message);
	  } finally {
	    this.traceCodeLoading = false;
	    this.getSomeWareLoading = false;
	  }
	},
	
	// 清除验证结果
	clearValidationResult() {
	  this.getSomeWareResult = null;
	},
	
	// 清空所有已扫描的药品
	clearAllScannedMedicines() {
	  this.$confirm('确定要清空所有已扫描的药品吗？', '提示', {
	    confirmButtonText: '确定',
	    cancelButtonText: '取消',
	    type: 'warning'
	  }).then(() => {
	    this.scannedMedicineList = [];
	    this.getSomeWareResult = null;
	    this.$message.success('已清空所有已扫描的药品');
	  });
	},
	
	// 从字符串中提取数字
	extractNumberFromString(str) {
	  if (!str) return 1;
	  
	  // 尝试匹配数字
	  const match = str.match(/\d+/g);
	  if (match && match.length > 0) {
	    // 取第一个数字
	    const num = parseInt(match[0], 10);
	    return isNaN(num) || num <= 0 ? 1 : num;
	  }
	  
	  return 1;
	},
	
	// 添加到已扫描列表
	addToScannedList(medicineData) {
	  // 确保 medicineData 存在
	  if (!medicineData) {
	    console.error('addToScannedList: medicineData 为空');
	    return;
	  }
	  
	  // 确保 scannedMedicineList 存在
	  if (!this.scannedMedicineList) {
	    console.log('scannedMedicineList 未定义，初始化空数组');
	    this.scannedMedicineList = [];
	  }
	  
	  // 确保 scannedMedicineList 是数组
	  if (!Array.isArray(this.scannedMedicineList)) {
	    console.error('scannedMedicineList 不是数组，重新初始化为空数组');
	    this.scannedMedicineList = [];
	  }
	  
	  // 检查是否已存在相同的药品名称
	  const existingIndex = this.scannedMedicineList.findIndex(item => 
	    item && item.drugName === medicineData.drugName && 
	    item.traceCode === medicineData.traceCode
	  );
	  
	  if (existingIndex !== -1) {
	    // 更新已存在的药品
	    this.$set(this.scannedMedicineList, existingIndex, medicineData);
	    this.$message.info(`已更新药品"${medicineData.drugName}"的信息`);
	  } else {
	    // 添加新的药品
	    this.scannedMedicineList.push(medicineData);
	    this.$message.success(`已添加药品"${medicineData.drugName}"到列表`);
	  }
	  
	  console.log('添加到已扫描列表后的药品信息:', {
	    drugName: medicineData.drugName,
	    saleUnt: medicineData.saleUnt,
	    editable: medicineData.editable
	  });
	  
	  // 自动滚动到底部
	  this.$nextTick(() => {
	    const container = this.$refs.scannedMedicineTable;
	    if (container) {
	      container.scrollTop = container.scrollHeight;
	    }
	  });
	},
	
	// 移除已扫描的药品
	removeScannedMedicine(index) {
	  this.scannedMedicineList.splice(index, 1);
	  this.$message.success('已移除药品');
	},
	
	// 打开扫码对话框为特定行
	openScanDialogForRow(row, index) {
	  this.currentScanItem = row;
	  this.currentScanIndex = index;
	  this.scanInput = '';
	  this.scanDialogVisible = true;
	  
	  this.$nextTick(() => {
	    this.$refs.scanInput?.focus();
	  });
	},
	
	// 编辑追溯码
	editTraceCode(row, index) {
	  this.currentScanItem = row;
	  this.currentScanIndex = index;
	  this.scanInput = row.drgTracCode || '';
	  this.scanDialogVisible = true;
	  
	  this.$nextTick(() => {
	    this.$refs.scanInput?.focus();
	  });
	},
	
	// 删除追溯码
	removeTraceCode(row, index) {
	  this.$confirm('确定要删除此追溯码吗？', '提示', {
	    confirmButtonText: '确定',
	    cancelButtonText: '取消',
	    type: 'warning'
	  }).then(() => {
	    this.$set(this.traceCodeTableData[index], 'drgTracCode', '');
	    this.$set(this.traceCodeTableData[index], 'drgTracCnt', 0);
	    this.$set(this.traceCodeTableData[index], 'sendStatus', '未关联');
	    this.$message.success('追溯码已删除');
	  });
	},
	
	// 新增：发药前数据验证
	async validateSendDataPreCheck() {
	  this.progressStep = 0;
	  this.progressStep1Desc = '数据验证中...';
	  
	  // 检查是否有选中处方
	  if (!this.rightForm.id) {
	    throw new Error('未选择处方，请先双击选择处方');
	  }
	  
	  // 检查药品列表
	  if (!this.rightTableData || this.rightTableData.length === 0) {
	    throw new Error('处方中没有药品数据');
	  }
	  
	  // 检查强制追溯码药品
	  const mandatoryTraceDrugs = this.rightTableData.filter(item => item.drugTracB === 1);
	  const uncollectedDrugs = mandatoryTraceDrugs.filter(item => !item.drgTracCode || item.drgTracCode.trim() === '');
	  
	  if (uncollectedDrugs.length > 0) {
	    const drugNames = uncollectedDrugs.map(item => item.drugName || '未知药品').join('、');
	    throw new Error(`以下强制追溯码药品未采集追溯码: ${drugNames}`);
	  }
	  
	  this.addProgressDetail('数据验证通过', 'success');
	  this.progressStep1Desc = '数据验证完成';
	},
	// 处理非医保用户完成流程
	async handleNonInsuranceUser() {
	  this.progressStep = 3;
	  this.progressStep3Desc = '非医保用户，跳过上传';
	  
	  this.addProgressDetail('当前用户为非医保用户，无需调用医保接口', 'info');
	  this.addProgressDetail('发药流程已完成', 'success');
	  
	  // 立即刷新表格数据
	  await this.refreshTableData();
	  
	  // 设置进度完成状态
	  this.progressLoading = false;
	  
	  // 非医保用户：发药成功后直接关闭进度条并刷新数据
	  setTimeout(() => {
	    this.progressDialogVisible = false;
	    this.$message.success('发药成功');
	  }, 1000);
	},
	
	// 修改第三步：上传医保接口（增加医保用户判断）
	async uploadToMedicalInsurance() {
	  // 首先检查用户是否为医保用户
	  if (!this.checkUserInsuranceStatus()) {
	    this.addProgressDetail('当前用户为非医保用户，跳过医保接口调用', 'info');
	    this.progressStep3Desc = '非医保用户，跳过上传';
	    
	    // 非医保用户直接完成流程
	    await this.handleNonInsuranceUser();
	    return;
	  }
	  
	  this.progressStep = 3;
	  this.progressStep3Desc = '准备上传...';
	  
	  try {
	    this.addProgressDetail('正在准备上传医保3505（商品销售）接口', 'info');
	    this.progressStep3Desc = '上传中...';
	    
	    // 准备医保上传数据
	    const insuranceData = this.prepareInsuranceData();
	    
	    this.addProgressDetail('开始调用医保3505接口...', 'info');
	    
	    // 调用医保接口
	    const res = await this.toYb3505(insuranceData);
	    if (res.infcode === 0) {
	      this.addProgressDetail('医保数据上传成功', 'success');
	      this.progressStep3Desc = '上传成功';
	      
	      // 调用addInfYB接口记录日志
	      this.addProgressDetail('医保3505商品采购信息上传成功！正在记录日志信息中...');
	      
	      // 准备addInfYB接口参数
	      const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
	      const logParams = {
	        operationTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	        tradingCode: res.msgid || `TR${dayjs().format('YYYYMMDDHHmmss')}`,
	        ifxType: 1, // 类型 1西药
	        fixmeDinsBchNo: this.rightForm.rxNo || '', // 流水号 / 处方编号
	        personNum: userData.staffId || '', // 人员编号id
	        settlementId: this.rightForm.id || '', // 结算ID / id
	        smtSerialNum: this.rightForm.patientId || '', // 就诊id/ 健康id
	        status: 1 // 1有效
	      };
	      
	      // 调用addInfYB接口
	      const logResult = await addInfYB(logParams);
	      
	      if (logResult.code === 200) {
	        this.addProgressDetail('日志信息保存成功！', 'success');
	      } else {
	        this.addProgressDetail(`日志信息保存失败: ${logResult.message}`, 'warning');
	      }
	      
	      // 设置3秒后自动刷新
	      this.timer = setTimeout(() => {
	        this.loadData();
	      }, 3000);
	      
	    } else {
	      this.addProgressDetail(`医保数据上传失败: ${res.err_msg}`, 'error');
	      this.progressStep3Desc = '上传失败';
	      this.progressHasError = true;
	    }
	    
	  } catch (error) {
	    this.addProgressDetail(`医保接口调用异常: ${error.message}`, 'error');
	    this.progressStep3Desc = '上传异常';
	    this.progressHasError = true;
	  }
	},
	
	// 刷新表格数据
	async refreshTableData() {
	  try {
	    this.addProgressDetail('正在更新表格数据...', 'info');
	    
	    // 重新加载左侧表格数据
	    await this.loadData();
	    
	    // 清空当前右侧表单和表格数据
	    this.rightForm = {
	      "age": 0,
	      "agnterCretno": "",
	      "agnterName": "",
	      "cardId": "",
	      "deptName": "",
	      "fullName": "",
	      "westernDiagnos": "",
	      "id": 0,
	      "name": "",
	      "patientId": 0,
	      "remark": "",
	      "rxName": "",
	      "rxNo": 0,
	      "saleAmt": 0,
	      "sex": 0,
	      "skintstRx": 0,
	      "state": 0,
	      "voList": []
	    };
	    this.rightTableData = [];
	    
	    // 清空搜索条件
	    this.form.healthId = '';
	    this.form.prescriptionSearch = '';
	    this.form.name = '';
	    
	    // 强制重新计算合计行
	    this.$nextTick(() => {
	      this.$refs.rightTable?.doLayout();
	    });
	    
	    this.addProgressDetail('表格数据更新完成', 'success');
	    
	  } catch (error) {
	    console.error('刷新表格数据失败:', error);
	    this.addProgressDetail('表格数据更新失败', 'error');
	  }
	},
	
	// 第一步：检查追溯码
	async checkTraceCodes() {
	  this.progressStep = 1;
	  this.progressStep1Desc = '检查中...';
	  
	  // 检查是否有强制追溯码药品未采集
	  const hasUncollected = this.rightTableData.some(item => 
	    item.drugTracB === 1 && (!item.drgTracCode || item.drgTracCode === '')
	  );
	  
	  if (hasUncollected) {
	    this.addProgressDetail('存在强制追溯码药品未采集，请先完成采集', 'error');
	    throw new Error('存在强制追溯码药品未采集');
	  }
	  
	  // 检查已采集的追溯码
	  const traceCodeItems = this.rightTableData.filter(item => 
	    item.drugTracB === 1 && item.drgTracCode && item.drgTracCode !== ''
	  );
	  
	  if (traceCodeItems.length > 0) {
	    this.addProgressDetail(`已录入 ${traceCodeItems.length} 个药品的追溯码`, 'success');
	    this.progressStep1Desc = '追溯码已录入完成';
	  } else {
	    this.addProgressDetail('无强制追溯码药品需要录入', 'info');
	    this.progressStep1Desc = '无追溯码需要录入';
	  }
	  
	  // 模拟检查耗时
	  await new Promise(resolve => setTimeout(resolve, 500));
	},
	
	// 第二步：执行发药
	async executeMedicineDispensing() {
	  this.progressStep = 2;
	  this.progressStep2Desc = '执行中...';
	  
	  try {
	    // 准备发药数据 - 确保所有必要字段都有值
	    const sendData = {
	      id: this.rightForm.id, // 处方ID
	      voList: this.rightTableData.map(item => {
	        // 构建每个药品的发药数据
	        const medicineData = {
	          id: item.id || item.rdDetailsId, // 明细ID，兼容不同字段名
	          drgTracCnt: Number(item.drgTracCnt) || 0,
	          drgTracCode: item.drgTracCode || '',
	          drugTracB: Number(item.drugTracB) || 0,
	          drugTracMaxCnt: Number(item.drugTracMaxCnt) || 0,
	          drugTracMaxId: Number(item.drugTracMaxId) || 0,
	          drugTracMinId: Number(item.drugTracMinId) || 0,
	          // 添加其他必要字段
	          cnt: Number(item.cnt) || 0,
	          purcPric: Number(item.purcPric) || 0,
	          saleAmt: Number(item.saleAmt) || 0
	        };
	        
	        // 打印调试信息
	        console.log('药品发药数据:', medicineData);
	        return medicineData;
	      })
	    };
	    
	    // 打印完整的发药数据
	    console.log('完整发药数据:', sendData);
	    
	    this.addProgressDetail('开始调用发药接口...', 'info');
	    
	    // 调用发药接口
	    let res = await fySave(sendData);
	    if (res.code === 200) {
	      this.addProgressDetail('发药成功', 'success');
	      this.progressStep2Desc = '发药完成';
	      
	      // 返回发药结果和用户信息
	      return { 
	        success: true, 
	        data: res.data,
	        isInsurance: this.checkUserInsuranceStatus()
	      };
	    } else {
	      this.addProgressDetail(`发药失败: ${res.message}`, 'error');
	      this.progressStep2Desc = '发药失败';
	      return { success: false, message: res.message };
	    }
	    
	  } catch (error) {
	    this.addProgressDetail(`发药接口调用异常: ${error.message}`, 'error');
	    this.progressStep2Desc = '发药异常';
	    return { success: false, message: error.message };
	  }
	},
	// 新增：验证发药数据完整性
	validateSendData(sendData) {
	  if (!sendData.id) {
	    throw new Error('处方ID不能为空');
	  }
	  
	  if (!sendData.voList || sendData.voList.length === 0) {
	    throw new Error('发药药品列表不能为空');
	  }
	  
	  // 检查每个药品的必要字段
	  for (let i = 0; i < sendData.voList.length; i++) {
	    const item = sendData.voList[i];
	    
	    if (!item.id) {
	      throw new Error(`第${i + 1}个药品缺少明细ID`);
	    }
	    
	    if (item.drugTracB === 1 && !item.drgTracCode) {
	      throw new Error(`药品 ${item.drugName || '未知'} 需要追溯码但未提供`);
	    }
	    
	    if (item.cnt <= 0) {
	      throw new Error(`药品 ${item.drugName || '未知'} 的数量必须大于0`);
	    }
	  }
	  
	  return true;
	},
	// 检查用户医保状态
	checkUserInsuranceStatus() {
	  try {
	    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	    return userInfo.isInsurance === 1; // 返回true/false
	  } catch (error) {
	    console.error('获取用户医保状态失败:', error);
	    return false;
	  }
	},
	
	// 新增：医保3505接口方法
	// async toYb3505(insuranceData) {
	//   // 1. 准备医保3505接口参数
	//   // 2. 引入ybapi，设置正确的请求头：customHeaders
	//   // 3. 引入ybapi，设置正确的请求体：requestBody
	//   // 4. 打印拼接设置好的请求参数
	//   // 5. 开始调用医保相关接口
	//   // 6. 打印医保接口响应
	//   // 7. 成功 / 失败 设置步骤进度条
	// },
	// 新增：医保3505接口方法
	async toYb3505(insuranceData) {
	  try {
	    this.addProgressDetail('开始准备医保3505接口数据...', 'info');
	    
	    // 1. 准备医保3505接口参数
	    const requestBody = this.prepareYb3505RequestBody(insuranceData);
	    
	    // 2. 先调用addYbRquestData接口
	    this.addProgressDetail('调用addYbRquestData接口准备医保数据...', 'info');
	    
	    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	    const newItem = {
	      infno: 3505,
	      mdtrtareaAdmvs: userInfo.mdtrtareaAdmvs || '',
	      data: JSON.stringify(requestBody),
	      patientId: userInfo.userId || '',
	      patientName: userInfo.username || ''
	    };
	    
	    const ybRequestRes = await addYbRquestData(newItem);
	    
	    if (ybRequestRes.code !== 200) {
	      throw new Error('医保数据准备失败: ' + ybRequestRes.message);
	    }
	    
	    this.addProgressDetail('医保数据准备完成，开始设置请求头...', 'info');
	    
	    let responseData = ybRequestRes.data;
	    if (typeof responseData === 'string') {
	      try {
	        responseData = JSON.parse(responseData);
	      } catch (parseError) {
	        throw new Error('解析医保响应数据失败');
	      }
	    }
	    
	    // 3. 生成医保标准请求头
	    const headers = this.generateYbHeaders(responseData);
	    
	    // 4. 打印请求参数（调试用）
	    console.log('医保3505接口请求参数:', requestBody);
	    
	    // 5. 开始调用医保相关接口
	    this.addProgressDetail('开始调用医保3505接口...', 'info');
	    
	    // 6. 调用医保接口
	    const res = await sendYbRequest(requestBody, headers);
	    
	    // 7. 打印医保接口响应
	    console.log('医保3505接口响应:', res);
	    
	    // 8. 处理响应结果
	    if (res.infcode === 0) {
	      this.addProgressDetail('医保数据上传成功' + res.output.result.exp_content, 'success');
	      this.progressStep3Desc = '上传成功';
	      
	      // 设置3秒后自动刷新
	      this.timer = setTimeout(() => {
	        this.loadData();
	      }, 3000);
	      
	      return res;
	    } else {
	      this.addProgressDetail(`医保数据上传失败: ${res.err_msg}`, 'error');
	      this.progressStep3Desc = '上传失败';
	      this.progressHasError = true;
	      return res;
	    }
	    
	  } catch (error) {
	    console.error('医保3505接口调用异常:', error);
	    this.addProgressDetail(`医保接口调用异常: ${error.message}`, 'error');
	    this.progressStep3Desc = '上传异常';
	    this.progressHasError = true;
	    throw error;
	  }
	},
	
	// 准备医保3505请求体 84176725733439158107
	prepareYb3505RequestBody(insuranceData) {
	  // 按照右边接口文档格式构建请求体
	  const userData = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  
	  const requestBody = {
	    // 头部信息
	    infno: '3505', // 接口编号
	    msgid: `${userData.clinicCode || '000000'}${dayjs().format('YYYYMMDDHHmmss')}${this.getRandom4Digits()}`,
	    mdtrtarea_admvs: userData.mdtrtareaAdmvs || '', // 就医地医保区划
	    insuplc_admdvs: userData.mdtrtareaAdmvs || '', // 参保地医保区划
	    recer_sys_code: '007', // 接收方系统代码
	    dev_no: '', // 设备号
	    fixmedins_code: userData.clinicCode || '', // 医药机构编号
	    fixmedins_name: userData.clinicName || '', // 医药机构名称
	    inf_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 入参时间
	    infver: 'V1.0', // 接口版本
	    opter: userData.userId || '', // 操作员
	    opter_name: userData.staffName || '', // 操作员姓名
	    opter_type: '1', // 操作员类型
	    recer_admdvs: userData.mdtrtareaAdmvs || '', // 接收方医保区划
	    sign_no: this.generateSignNo(), // 签到流水号
	    signtype: 'SM3', // 签名类型
	    cainfo: '', // CA信息
	    dev_safe_info: '', // 设备安全信息
	    
	    // 主体信息 - 直接使用selinfo节点，取消sel_list
	    input: {
	      selinfo: this.prepareSelInfo(insuranceData) // 销售信息主体
	    }
	  };
	  
	  return requestBody;
	},
	
	// 修改：准备input数据（按照左边截图格式）
	prepareInputData(insuranceData) {
	  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  
	  return {
	    // 销售信息主体
	    selinfo: {
	      // 基本信息
	      fixmedins_code: this.rightForm.fixmedins_code || '',
	      fixmedins_name: this.rightForm.fixmedins_name || '',
	      
	      // 销售信息
	      sel_list: this.prepareSelList(insuranceData.medicineList),
	      
	      // 时间信息
	      sel_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	      acpt_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	      
	      // 人员信息
	      psn_no: insuranceData.patientInfo.patientId || '',
	      psn_name: insuranceData.patientInfo.name || '',
	      psn_cert_type: '01', // 证件类型：身份证
	      certno: insuranceData.patientInfo.cardId || '',
	      
	      // 业务信息
	      sel_plc: this.form.dispensingWindow || '', // 销售地点
	      bilg_opt: this.rightForm.fullName || userInfo.username || '', // 开单医师
	      bilg_dept: this.rightForm.deptName || '', // 开单科室
	      
	      // 医保信息
	      mdtrt_id: insuranceData.patientInfo.mdtrtId || '', // 就诊ID
	      med_type: insuranceData.patientInfo.medType || '', // 医疗类别
	      setl_id: insuranceData.patientInfo.setlId || '', // 结算ID
	      
	      // 金额信息
	      tota_amt: this.rightForm.saleAmt || 0, // 总金额
	      acct_amt: this.rightForm.saleAmt || 0, // 账户金额
	      psn_part_amt: 0, // 个人自付
	      fund_part_amt: this.rightForm.saleAmt || 0 // 基金支付
	    }
	  };
	},
	
	// 修改：生成医保请求头（按照左边截图格式）
	generateYbHeaders(responseData) {
	  // 从addYbRquestData的响应中获取必要的头信息
	  const {
	    infosyscode = '',
	    signature = '',
	    hsfNonce = '',
	    hsfTimestamp = Date.now().toString()
	  } = responseData;
	  
	  // 获取用户和机构信息
	  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
	  
	  // 构建完整的请求头
	  return {
	    'Content-Type': 'application/json;charset=UTF-8',
	    'infosyscode': infosyscode || clinicInfo.infosyscode || process.env.VUE_APP_INFOSYS_CODE || '',
	    'hsf_signature': signature || this.generateSignature(hsfTimestamp),
	    'fixmedins_code': userInfo.clinicCode || '',
	    'hsf_nonce': hsfNonce || this.generateNonce(),
	    'hsf_timestamp': hsfTimestamp,
	    'opter': userInfo.userId || '',
	    'opter_name': userInfo.username || '',
	    'mdtrtarea_admvs': userInfo.mdtrtareaAdmvs || '',
	    'recer_sys_code': '007',
	    'infver': 'V1.0',
	    'inf_time': dayjs().format('YYYY-MM-DD HH:mm:ss'),
	    'Authorization': localStorage.getItem('token') || ''
	  };
	},

	// 修改：准备销售信息(selinfo节点) - 根据rightForm和voList中的数据取值
	prepareSelInfo(insuranceData) {
	  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	  
	  // 获取第一个药品信息（如果有）
	  const firstMedicine = this.rightTableData.length > 0 ? this.rightTableData[0] : {};
	  
	  return {
	    // 基本信息
	    fixmedins_code: userInfo.clinicCode || '',
	    fixmedins_name: userInfo.clinicName || '',
	    
	    // 销售信息 - 取消sel_list节点，将关键信息放在顶层
	    med_list_codg: firstMedicine.medListCodg || '', // 医疗目录编码
	    fixmedins_hilist_id: userInfo.clinicCode || '', // 定点医药机构目录编号
	    fixmedins_hilist_name: userInfo.clinicName || '', // 定点医药机构目录名称
	    fixmedins_bchno: this.rightForm.id || '', // 定点医药机构批次流水号
	    
	    // 人员信息
	    prsc_dr_cert_type: this.rightForm.prsc_dr_cert_type || '01', // 开方医师证件类型
	    prsc_dr_certno: this.rightForm.prsc_dr_certno || '', // 开方医师证件号码
	    prsc_dr_name: this.rightForm.fullName || '', // 开方医师姓名
	    phar_cert_type: this.rightForm.phar_cert_type || '01', // 药师证件类型
	    phar_certno: this.rightForm.phar_certno || '', // 药师证件号码
	    phar_name: userInfo.staffName || '', // 药师姓名
	    phar_prac_cert_no: this.rightForm.phar_prac_cert_no || '', // 药师执业资格证号
	    
	    // 患者信息
	    psn_no: this.rightForm.patientId?.toString() || '', // 人员编号
	    psn_cert_type: '01', // 人员证件类型
	    certno: this.rightForm.cardId || '', // 证件号码
	    psn_name: this.rightForm.name || '', // 人员姓名
	    
	    // 药品信息 - 使用第一个药品的信息
	    drug_name: firstMedicine.drugName || '', // 药品名称
	    drug_spec: firstMedicine.drugSpec || '', // 药品规格
	    manu_lotnum: firstMedicine.manuLotnum || '', // 生产批号
	    manu_date: firstMedicine.manuDate || '', // 生产日期
	    expy_end: firstMedicine.expyDate || '', // 有效期
	    
	    // 业务信息
	    rx_flag: this.rightForm.rx_flag || '1', // 处方药标志
	    trdn_flag: this.rightForm.trdn_flag || '0', // 拆零标志
	    finl_trns_pric: firstMedicine.purcPric?.toString() || '0', // 最终成交单价
	    rxno: this.rightForm.rxNo?.toString() || '', // 处方号
	    rx_circ_flag: this.rightForm.rx_circ_flag || '0', // 外购处方标志
	    rtal_docno: this.rightForm.id || '', // 零售单据号
	    stoout_no: this.rightForm.stoout_no || '', // 销售出库单据号
	    bchno: this.rightForm.bchno || '', // 批次号
	    
	    // 销售信息
	    pric: firstMedicine.purcPric?.toString() || '0', // 单价
	    cnt: firstMedicine.cnt?.toString() || '0', // 数量
	    amt: firstMedicine.saleAmt?.toString() || '0', // 金额
	    pac_cnt: firstMedicine.pacCnt?.toString() || '1', // 包装数量
	    
	    // 时间信息
	    sel_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 销售时间
	    acpt_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 接收时间
	    
	    // 地点信息
	    sel_plc: this.form.dispensingWindow || '', // 销售地点
	    bilg_opt: this.rightForm.fullName || '', // 开单医师
	    bilg_dept: this.rightForm.deptName || '', // 开单科室
	    
	    // 医保信息
	    hi_feesetl_type: this.rightForm.hi_feesetl_type || '1', // 医保费用结算类型
	    setl_id: this.rightForm.setl_id || '', // 结算ID
	    mdtrt_sn: firstMedicine.rxId || '', // 就医流水号
	    mdtrt_id: this.rightForm.mdtrt_id || '', // 就诊ID
	    med_type: this.rightForm.med_type || '', // 医疗类别
	    
	    // 金额信息
	    tota_amt: this.rightForm.saleAmt?.toString() || '0', // 总金额
	    acct_amt: this.rightForm.saleAmt?.toString() || '0', // 账户金额
	    psn_part_amt: '0', // 个人自付
	    fund_part_amt: this.rightForm.saleAmt?.toString() || '0', // 基金支付
	    
	    // 追溯码信息
	    drug_trac_codg: firstMedicine.drgTracCode || '', // 药品追溯码
	    drug_prod_barc: firstMedicine.drug_prod_barc || '', // 药品条形码
	    shelf_posi: firstMedicine.shelf_posi || '', // 货架位
	    
	    // 销售/退货信息
	    sel_retn_cnt: firstMedicine.cnt?.toString() || '0', // 销售/退货数量
	    sel_retn_time: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 销售/退货时间
	    sel_retn_opter_name: userInfo.staffName || '', // 销售/退货经办人姓名
	    
	    // 其他信息
	    memo: this.rightForm.remark || '', // 备注
	    mdtrt_setl_type: this.rightForm.mdtrt_setl_type || '1' // 就诊结算类型
	  };
	},

	
	// 准备销售明细列表(sel_list节点)
	prepareSelList(medicineList) {
	  return medicineList.map((item, index) => ({
		sel_list_sn: (index + 1).toString(), // 销售明细流水号
		med_list_codg: item.medListCodg || '', // 医疗目录编码
		medins_list_codg: item.medinsListCodg || '', // 医药机构目录编码
		drug_name: item.drugName || '', // 药品名称
		drug_spec: item.drugSpec || '', // 药品规格
		pric: item.price || 0, // 单价
		cnt: item.quantity || 0, // 数量
		amt: item.amount || 0, // 金额
		pac_cnt: item.packageCount || 1, // 包装数量
		manu_date: item.manuDate, // 生产日期
		expy_date: item.expyDate, // 有效期至
		manu_lotnum: item.manuLotnum || '', // 批号
		prodentp_name: item.prodentpName || '', // 生产企业名称
		
		// 追溯码信息
		drug_trac_codg: item.traceCode || '', // 药品追溯码
		drug_trac_cnt: item.drgTracCnt || 1, // 药品追溯码数量
	  }));
	},
	
	// 准备药品追溯信息
	prepareDrugTracInfo() {
	  const traceCodes = this.rightTableData
		.filter(item => item.drgTracCode && item.drgTracCode.trim() !== '')
		.map(item => item.drgTracCode);
	  
	  return traceCodes.map((code, index) => ({
		drug_trac_sn: (index + 1).toString(), // 药品追溯流水号
		drug_trac_codg: code, // 药品追溯码
		drug_trac_cnt: 1, // 药品追溯码数量
		associa_sellist_sn: (index + 1).toString(), // 关联销售明细流水号
	  }));
	},
	
	// 新增：生成签到流水号方法
	generateSignNo() {
	  const timestamp = dayjs().format('YYYYMMDDHHmmss');
	  const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
	  return `S${timestamp}${randomNum}`;
	},
	// 生成签名(增强实现)
	generateSignature(timestamp) {
	  try {
	    // 获取必要的签名参数
	    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
	    const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
	    
	    // 构建签名字符串（根据医保局要求）
	    const signString = `${timestamp}${clinicInfo.clinicCode || ''}${userInfo.userId || ''}${this.rightForm.rxNo || ''}`;
	    
	    // 这里应该使用实际的签名算法（如SM2/SM3）
	    // 由于浏览器环境限制，这里使用btoa作为示例
	    // 实际项目中应该使用后端提供的签名服务或前端加密库
	    return btoa(encodeURIComponent(signString));
	  } catch (error) {
	    console.error('生成签名失败:', error);
	    // 返回默认签名
	    return `sign_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
	  }
	},
	
	// 生成随机数（增强实现）
	generateNonce() {
	  // 生成更安全的随机数
	  const array = new Uint32Array(4);
	  window.crypto.getRandomValues(array);
	  return Array.from(array, dec => dec.toString(16).padStart(8, '0')).join('');
	},
	
	// 生成消息ID
	// 生成消息ID（增强实现）
		generateMsgId() {
		  const timestamp = dayjs().format('YYYYMMDDHHmmss');
		  const clinicInfo = JSON.parse(localStorage.getItem('clinicInfo') || '{}');
		  const randomNum = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
		  
		  return `${clinicInfo.clinicCode || '000000'}${timestamp}${randomNum}`;
		},
		
		// 获取4位随机数
		getRandom4Digits() {
			return Math.floor(1000 + Math.random() * 9000).toString();
		},
		// 处理进度完成
		handleProgressComplete() {
		  this.progressDialogVisible = false;
		  
		  // 如果是非医保用户，确保数据已经刷新
		  if (!this.checkUserInsuranceStatus()) {
		    this.$message.success('发药流程已完成');
		  }
		},
		// 准备医保上传数据
		prepareInsuranceData() {
		  // 这里根据实际业务需求准备医保上传数据
		  return {
		    businessType: '3505',
		    patientInfo: {
		      name: this.rightForm.name,
		      cardId: this.rightForm.cardId,
		      patientId: this.rightForm.patientId
		    },
		    prescriptionInfo: {
		      rxNo: this.rightForm.rxNo,
		      rxName: this.rightForm.rxName,
		      totalAmount: this.rightForm.saleAmt
		    },
		    medicineList: this.rightTableData.map(item => ({
		      drugName: item.drugName,
		      drugSpec: item.drugSpec,
		      quantity: item.cnt,
		      unit: item.unt,
		      price: item.purcPric,
		      amount: item.saleAmt,
		      traceCode: item.drgTracCode || ''
		    })),
		    traceCodes: this.rightTableData
		      .filter(item => item.drgTracCode && item.drgTracCode !== '')
		      .map(item => item.drgTracCode)
		  };
		},
		
		// 添加进度详情
		addProgressDetail(message, type = 'info') {
		  this.progressDetails.push({
		    message,
		    type,
		    time: new Date().toLocaleTimeString()
		  });
		  
		  // 保持滚动到底部
		  this.$nextTick(() => {
		    const container = this.$el.querySelector('.details-content');
		    if (container) {
		      container.scrollTop = container.scrollHeight;
		    }
		  });
		},
		
		// 修改 getDataValue 方法
		getDataValue(row) {
		  console.log('双击行数据:', row);
		  
		  // 深拷贝数据
		  this.rightForm = JSON.parse(JSON.stringify(row));
		  
		  // 确保 voList 存在
		  if (row.voList && Array.isArray(row.voList)) {
		    this.rightTableData = row.voList.map(item => ({
		      ...item,
		      drugTracB: item.drugTracB || 0,
		      isBar: item.isBar || 0, // 新增字段
		      purcAmt: Number(item.purcAmt) || 0,
		      cnt: Number(item.cnt) || 0,
		      purcPric: Number(item.purcPric) || 0,
		      saleAmt: Number(item.saleAmt) || 0,
		      drgTracCode: item.drgTracCode || '',
		      drgTracCnt: Number(item.drgTracCnt) || 0,
		      drugTracMaxCnt: Number(item.drugTracMaxCnt) || 0,
		      drugTracMaxId: Number(item.drugTracMaxId) || 0,
		      drugTracMinId: Number(item.drugTracMinId) || 0
		    }));
		    
		    // 检查是否有必须扫码的药品
		    this.checkBarRequiredStatus();
		  } else {
		    this.rightTableData = [];
		  }
		  
		  this.$nextTick(() => {
		    if (this.$refs.rightTable) {
		      this.$refs.rightTable.doLayout();
		    }
		  });
		},
		
		// 新增：检查是否有必须扫码的药品
		checkBarRequiredStatus() {
		  this.isBarRequired = this.rightTableData.some(item => item.isBar === 1);
		  if (this.isBarRequired) {
		    this.tooltipMessage = '当前药品需进行追溯码的录入与上传，请点击上方发药内容中的"追溯码"进行追溯码录入，录入完成后方可完成发药。';
		  }
		},
			
		// 切换药品列表显示
		toggleMedicineList() {
		  this.showMedicineList = !this.showMedicineList;
		  
		  // 添加平滑展开/收起动画
		  this.$nextTick(() => {
			const listElement = this.$el.querySelector('.medicine-list');
			if (listElement) {
			  listElement.style.transition = 'max-height 0.3s ease';
			  listElement.style.overflow = 'hidden';
			  
			  if (this.showMedicineList) {
				listElement.style.maxHeight = '0';
				setTimeout(() => {
				  listElement.style.maxHeight = listElement.scrollHeight + 'px';
				}, 10);
			  } else {
				listElement.style.maxHeight = listElement.scrollHeight + 'px';
				setTimeout(() => {
				  listElement.style.maxHeight = '0';
				}, 10);
			  }
			}
		  });
		},
	
		// 修改 sendMedic 方法
		async sendMedic() {
		  // 检查是否有患者信息
		  if (!this.rightForm.patientId || !this.rightForm.name) {
		    this.$message.warning('暂未查询到患者诊断信息');
		    return;
		  }
		  
		  // 检查是否有必须扫码的药品
		  this.checkBarRequiredStatus();
		  
		  // 设置发药对话框数据
		  this.sendMedicineData = {
		    patientName: this.rightForm.name,
		    diagnosis: this.rightForm.westernDiagnos,
		    traceCodeCount: this.calculateTraceCodeCount(),
		    medicineCount: this.calculateMedicineCount(),
		    printTogether: false
		  };
		  
		  // 设置追溯码采集对话框标题
		  this.traceCodeDialogTitle = '追溯码录入采集与上传';
		  
		  // 根据是否有强制追溯码药品决定是否展开
		  this.showMedicineList = this.isBarRequired;
		  
		  // 加载药品数据
		  this.loadWesternMedicines();
		  
		  // 显示发药对话框
		  this.sendMedicineDialogVisible = true;
		},
	
		// 加载西药数据 - 添加默认值避免报错
		loadWesternMedicines() {
		  this.westernMedicines = this.rightTableData.map(item => ({
			...item,
			// 确保drugTracB有默认值
			drugTracB: item.drugTracB || 0,
			traceCodeCollected: false // 初始化为未采集状态
		  }));
		},
		
		// 计算已采集的追溯码数量
		calculateTraceCodeCount() {
		  let count = 0;
		  
		  // 计算右侧表格中已采集的追溯码数量
		  this.rightTableData.forEach(item => {
		    // 只计算强制追溯码药品
		    if (item.isBar === 1) {
		      // 检查是否已采集追溯码
		      if (item.drgTracCode && item.drgTracCode.trim() !== '') {
		        count += 1;
		      }
		    }
		  });
		  
		  console.log('计算追溯码数量: 药品数量=', this.rightTableData.length, '追溯码数量=', count);
		  return count;
		},
		
		// 计算药品数量
		calculateMedicineCount() {
		  // 根据实际业务逻辑计算
		  return this.rightTableData.length || 0;
		},
		
		// 打开追溯码采集对话框
		openTraceCodeDialog() {
		  this.traceCodeDialogVisible = true;
		  this.traceCodeDialogTitle = '追溯码录入采集与上传'; // 设置标题
		  this.scanButtonText = '查询'; // 修改按钮文本
		  this.traceCodeTableData = this.transformToTraceCodeData(this.westernMedicines);
		},
		
		// 打开扫码对话框
		openScanDialog(item) {
		  this.currentScanItem = item;
		  this.scanInput = '';
		  this.scanDialogVisible = true;
		  
		  // 自动聚焦输入框
		  this.$nextTick(() => {
			this.$refs.scanInput?.focus();
		  });
		},
		
		async handleScanInput() {
		  if (!this.scanInput || !this.currentScanItem) {
		    this.$message.warning('请输入追溯码');
		    return;
		  }
		  
		  this.scanLoading = true;
		  try {
		    // 调用码上放心接口查询追溯码
		    const res = await msfxCodeDetail({ codes: this.scanInput });
		    
		    if (res.code === 200 && res.data && res.data.length > 0) {
		      const traceCodeInfo = res.data[0];
		      
		      // 提取药品信息
		      if (traceCodeInfo.drugEntBaseDTO) {
		        const drugInfo = traceCodeInfo.drugEntBaseDTO;
		        const drugName = drugInfo.physicName || '未知药品';
		        
		        // 提取包装数量
		        const prepnSpec = drugInfo.prepnSpec || '1';
		        const pacCnt = this.extractNumberFromString(prepnSpec) || 1;
		        
		        // 调用 getSomeWare 接口检查药品是否存在
		        const wareRes = await getSomeWare({ 
		          drugName: drugName,
		          traceCode: this.scanInput
		        });
		        
		        if (!wareRes.data || wareRes.data.length === 0) {
		          // 药品不存在，显示警告
		          this.$confirm(
		            '当前追溯码的对应药品信息不存在于本系统中！请仔细检查，如果确认追溯码无误，则您可以点击此处，去进行本系统的药品基本档案维护！',
		            '警告',
		            {
		              confirmButtonText: '去维护',
		              cancelButtonText: '取消',
		              type: 'warning',
		              dangerouslyUseHTMLString: true
		            }
		          ).then(() => {
		            // 携带数据跳转到 /Western 路由
		            this.$router.push({
		              path: '/Western',
		              query: {
		                traceCodeData: JSON.stringify(traceCodeInfo)
		              }
		            });
		          });
		        } else {
		          // 药品存在，允许关联
		          this.associateTraceCode(traceCodeInfo, pacCnt);
		        }
		      }
		    } else {
		      this.$message.error('未查询到追溯码信息');
		    }
		  } catch (error) {
		    console.error('查询追溯码失败:', error);
		    this.$message.error('查询追溯码失败: ' + error.message);
		  } finally {
		    this.scanLoading = false;
		  }
		},
		
		// 新增：关联追溯码
		associateTraceCode(traceCodeInfo, pacCnt) {
		  // 更新匹配到的药品
		  this.matchedMedicines.forEach(medicine => {
		    medicine.drgTracCode = this.scanInput;
		    medicine.drgTracCnt = medicine.drgTracCnt ? medicine.drgTracCnt + 1 : 1;
		    medicine.traceCodeCollected = true;
		    medicine.traceCodes = medicine.traceCodes || [];
		    medicine.traceCodes.push({
		      traceCode: this.scanInput,
		      pacCnt: pacCnt,
		      traceInfo: traceCodeInfo
		    });
		    
		    // 更新其他数据
		    this.updateMedicineData(medicine);
		  });
		  
		  this.$message.success('追溯码绑定成功');
		  this.scanDialogVisible = false;
		  this.scanInput = '';
		},
		
		// 新增：更新药品数据
		updateMedicineData(medicine) {
		  // 更新追溯码表格
		  const index = this.traceCodeTableData.findIndex(
		    item => item.rawData && item.rawData.drugId === medicine.drugId
		  );
		  
		  if (index !== -1) {
		    this.$set(this.traceCodeTableData, index, {
		      ...this.traceCodeTableData[index],
		      drgTracCode: medicine.drgTracCode,
		      drgTracCnt: medicine.drgTracCnt,
		      sendStatus: '已关联',
		      pacCnt: medicine.traceCodes[0]?.pacCnt || 1
		    });
		  }
		  
		  // 更新右侧表格
		  const rightIndex = this.rightTableData.findIndex(
		    item => item.drugId === medicine.drugId
		  );
		  
		  if (rightIndex !== -1) {
		    this.$set(this.rightTableData, rightIndex, { ...medicine });
		  }
		  
		  // 更新 westernMedicines
		  const westIndex = this.westernMedicines.findIndex(item => item.drugId === medicine.drugId);
		  if (westIndex !== -1) {
		    this.$set(this.westernMedicines, westIndex, { ...medicine });
		  }
		},
	
		// 查找匹配的药品
		findMatchingMedicines() {
		    this.matchedMedicines = [];
		      
		    // 检查当前处方是否有药品数据
		    if (!this.rightTableData || this.rightTableData.length === 0) {
		      this.$message.warning('当前处方无药品信息');
		      return;
		    }
		      
		    // 遍历rightTableData查找匹配的药品
		    this.rightTableData.forEach(item => {
		      // 确保drugTracMaxId是字符串类型
		      const maxId = String(item.drugTracMaxId || '');
		          
		      // 检查追溯码前缀是否匹配
		      if (maxId === this.traceCodePrefix) {
		        this.matchedMedicines.push({
		          ...item, // 包含药品完整信息
		          traceId: this.traceCodePrefix,  // 追溯标识码
		          fullTraceCode: this.scanInput   // 完整追溯码
		        });
		      }
		    });
		      
		    if (this.matchedMedicines.length === 0) {
		      this.$message.error(`未找到匹配的药品信息，追溯码前缀: ${this.traceCodePrefix}`);
		    } else {
		      this.$message.success(`找到${this.matchedMedicines.length}个匹配的药品`);
			  console.log(this.matchedMedicines,'找到${this.matchedMedicines.length}个匹配的药品');
		    }
		},
	
		// 在扫码对话框中确认绑定追溯码
		async confirmTraceCode() {
		  if (!this.currentScanItem || this.matchedMedicines.length === 0) {
		    this.$message.warning('请先扫描有效的追溯码');
		    return;
		  }
		  
		  const scanInput = this.scanInput;
		  
		  // 更新匹配到的药品的追溯码信息
		  this.matchedMedicines.forEach(medicine => {
		    // 更新追溯码和数量
		    medicine.drgTracCode = scanInput;
		    medicine.drgTracCnt = medicine.drgTracCnt ? medicine.drgTracCnt + 1 : 1;
		    
		    // 标记为已采集
		    medicine.traceCodeCollected = true;
		    
		    // 更新追溯码表格数据
		    this.updateTraceCodeTableData(medicine);
		    
		    // 更新右侧表格数据
		    this.updateRightTableData(medicine);
		    
		    // 修复：确保更新 westernMedicines 中的对应项
		    const index = this.westernMedicines.findIndex(item => item.drugId === medicine.drugId);
		    if (index !== -1) {
		      // 使用 Vue.set 确保响应性
		      this.$set(this.westernMedicines, index, {
		        ...this.westernMedicines[index],
		        drgTracCode: scanInput,
		        drgTracCnt: medicine.drgTracCnt,
		        traceCodeCollected: true
		      });
		    }
		  });
		  
		  this.$message.success('追溯码绑定成功');
		  this.scanDialogVisible = false;
		  
		  // 更新发药对话框中的追溯码数量
		  this.sendMedicineData.traceCodeCount = this.calculateTraceCodeCount();
		},
		
		// 更新追溯码表格数据
		updateTraceCodeTableData(medicine) {
		    const index = this.traceCodeTableData.findIndex(
		      item => item.rawData && item.rawData.drugId === medicine.drugId
		    );
		    
		    if (index !== -1) {
		      const updatedItem = {
		        ...this.traceCodeTableData[index],
		        drgTracCode: medicine.drgTracCode,
		        drgTracCnt: medicine.drgTracCnt,
		        sendStatus: '已关联'
		      };
		      
		      this.$set(this.traceCodeTableData, index, updatedItem);
		    }
		},
		
		// 更新发药对话框数据
		updateSendMedicineData() {
		  // 更新药品数量
		  this.sendMedicineData.medicineCount = this.rightTableData.length;
		  
		  // 更新追溯码数量
		  this.sendMedicineData.traceCodeCount = this.calculateTraceCodeCount();
		  
		  console.log('更新发药对话框数据:', this.sendMedicineData);
		  
		  // 强制更新视图
		  this.$forceUpdate();
		},
		
		// 更新右侧表格数据
		updateRightTableData(medicine) {
		  const index = this.rightTableData.findIndex(
			item => item.drugId === medicine.drugId
		  );
		  
		  if (index !== -1) {
			this.$set(this.rightTableData, index, {...medicine});
		  }
		},
			
		// 更新药品状态
		updateMedicineStatus() {
		    // 检查是否所有强制追溯码药品都已采集
		    const allCollected = this.westernMedicines.every(item => 
		      item.drugTracB !== 1 || item.traceCodeCollected
		    );
		    
		    if (allCollected) {
		      this.$message.success('所有强制追溯码药品已完成采集');
		    }
		},
			
		// 更新追溯码数量显示
		updateTraceCodeCount() {
		  const traceCodeCount = this.calculateTraceCodeCount();
		  this.sendMedicineData.traceCodeCount = traceCodeCount;
		  console.log('更新追溯码数量:', traceCodeCount);
		},
		
		// 确认发药
		async confirmSendMedicine() {
		  this.sendMedicineDialogVisible = false;
		  
		  // 检查是否有必须扫码但未采集的药品
		  const hasUncollected = this.rightTableData.some(item => 
		    item.isBar === 1 && (!item.drgTracCode || item.drgTracCode.trim() === '')
		  );
		  
		  if (hasUncollected) {
		    this.$message.error('存在必须扫码药品未采集，请先完成采集');
		    return;
		  }
		  
		  // 检查是否已录入追溯码
		  const traceCodesCount = this.getCollectedTraceCodes().length;
		  if (traceCodesCount === 0 && this.hasMandatoryTraceDrugs()) {
		    this.$message.error('请先录入追溯码');
		    return;
		  }
		  
		  // 重置执行标志
		  this.step5Executed = false;
		  
		  // 直接走追溯码上传流程（最小单位已在追溯码录入模态框中处理完毕）
		  this.openTraceCodeUploadProgress();
		},
		
		// 为最小单位药品打开系统提示模态框
		openSystemPromptForMinUnitDrug(drugs) {
		  if (!drugs || drugs.length === 0) {
		    console.warn('没有需要重新录入发药数量的药品');
		    this.openTraceCodeUploadProgress();
		    return;
		  }
		  
		  // 获取第一个最小单位药品
		  const firstDrug = drugs[0];
		  this.systemPromptDrug = firstDrug;
		  
		  // 设置模态框标题
		  this.systemPromptTitle = `系统提示: 本次处方单据中发药药品【${firstDrug.drugName}】的销售单位为最小单位，需对发药数量进行重新录入`;
		  
		  // 构建表格数据
		  this.systemPromptData = [{
		    traceCode: firstDrug.drgTracCode || '无',
		    drugName: firstDrug.drugName,
		    spec: firstDrug.drugSpec,
		    cnt: firstDrug.cnt, // 当前发药数量
		    pacCnt: firstDrug.pacCnt, // 包装数量
		    manufacturer: firstDrug.prodentpName,
		    batchNo: firstDrug.manuLotnum
		  }];
		  
		  // 显示系统提示模态框
		  this.systemPromptVisible = true;
		},
		
		// 保存系统提示模态框中的发药数量
		saveSystemPromptCnt() {
		  if (!this.systemPromptDrug || this.systemPromptData.length === 0) {
		    this.$message.warning('没有药品数据');
		    return;
		  }
		  
		  const inputData = this.systemPromptData[0];
		  const newCnt = parseInt(inputData.cnt) || 0;
		  const pacCnt = parseInt(inputData.pacCnt) || 1;
		  
		  // 验证发药数量
		  if (newCnt <= 0) {
		    this.$message.warning('发药数量必须大于0');
		    return;
		  }
		  
		  if (newCnt > pacCnt) {
		    this.$message.warning(`发药数量不能超过包装数量 ${pacCnt}`);
		    return;
		  }
		  
		  console.log('更新发药数量:', {
		    药品名称: this.systemPromptDrug.drugName,
		    原发药数量: this.systemPromptDrug.cnt,
		    新发药数量: newCnt,
		    包装数量: pacCnt
		  });
		  
		  // 更新药品的发药数量
		  const index = this.rightTableData.findIndex(item => 
		    item.drugId === this.systemPromptDrug.drugId
		  );
		  
		  if (index !== -1) {
		    this.$set(this.rightTableData[index], 'cnt', newCnt);
		    this.$message.success(`已更新药品【${this.systemPromptDrug.drugName}】的发药数量`);
		  }
		  
		  // 关闭系统提示模态框
		  this.systemPromptVisible = false;
		  this.systemPromptDrug = null;
		  this.systemPromptData = [];
		  
		  // 继续处理下一个最小单位药品，或者开始追溯码上传流程
		  const remainingMinUnitDrugs = this.rightTableData.filter(item => 
		    item.saleUnt === 1 && item.isBar === 1 && item.cnt > 0
		  );
		  
		  if (remainingMinUnitDrugs.length > 0) {
		    // 还有需要处理的药品
		    setTimeout(() => {
		      this.openSystemPromptForMinUnitDrug(remainingMinUnitDrugs);
		    }, 500);
		  } else {
		    // 所有药品处理完成，开始追溯码上传流程
		    setTimeout(() => {
		      this.openTraceCodeUploadProgress();
		    }, 500);
		  }
		},
		
		// 打开追溯码上传进度对话框
		openTraceCodeUploadProgress() {
		  // 打开上传进度对话框
		  this.traceCodeUploadDialog = true;
		  this.traceCodeUploadStep = 0;
		  this.traceCodeUploadDetails = [];
		  this.traceCodeHasError = false;
		  this.showRetryButton = false;
		  this.uploadRetryCount = 0;
		  this.msfxUploading = false;
		  
		  try {
		    // 开始检查追溯码
		    this.checkTraceCodeUploadStep1();
		  } catch (error) {
		    console.error('打开追溯码上传流程失败:', error);
		    this.addTraceCodeUploadDetail('发药流程异常: ' + error.message, 'error');
		    this.traceCodeHasError = true;
		  }
		},
		
		// 取消系统提示
		cancelSystemPrompt() {
		  this.$confirm('确定要取消发药流程吗？', '提示', {
		    confirmButtonText: '确定',
		    cancelButtonText: '取消',
		    type: 'warning'
		  }).then(() => {
		    this.systemPromptVisible = false;
		    this.systemPromptDrug = null;
		    this.systemPromptData = [];
		    this.$message.info('已取消发药流程');
		  }).catch(() => {
		    // 用户取消关闭
		  });
		},
		
		// 步骤1：检查追溯码
		async checkTraceCodeUploadStep1() {
		  this.traceCodeUploadStep = 0;
		  this.traceCodeUploadSteps[0].description = '正在检查是否有药品需要录入追溯码...';
		  this.addTraceCodeUploadDetail('正在检查是否有药品需要录入追溯码...', 'info');
		  
		  // 计算已录入的追溯码数量
		  const traceCodes = this.getCollectedTraceCodes();
		  const traceCodeCount = traceCodes.length;
		  
		  // 更新步骤描述
		  this.traceCodeUploadSteps[0].description = `已检测到已录入追溯码 ${traceCodeCount} 个，已完成录入`;
		  this.addTraceCodeUploadDetail(`已检测到已录入追溯码 ${traceCodeCount}/${this.getMandatoryTraceDrugsCount()} 个，已完成录入`, 'success');
		  
		  // 延迟后进入下一步
		  setTimeout(() => {
		    this.checkTraceCodeUploadStep2();
		  }, 1000);
		},
		
		// 步骤2：接入码上放心平台
		async checkTraceCodeUploadStep2() {
		  this.traceCodeUploadStep = 1;
		  this.traceCodeUploadSteps[1].description = '正在接入码上放心平台接口...';
		  this.addTraceCodeUploadDetail('正在接入码上放心平台接口...', 'info');
		  
		  // 模拟接入过程
		  setTimeout(() => {
		    this.addTraceCodeUploadDetail('码上放心平台接口接入成功', 'success');
		    this.traceCodeUploadSteps[1].description = '码上放心平台接口已接入';
		    
		    // 延迟后进入下一步
		    setTimeout(() => {
		      this.checkTraceCodeUploadStep3();
		    }, 1000);
		  }, 1500);
		},
		
		// 步骤3：上传追溯码（调用msfxUploadRetail）
		async checkTraceCodeUploadStep3() {
		  this.traceCodeUploadStep = 2; // 索引恢复为2
		  this.traceCodeUploadSteps[2].description = '正在上传发药明细追溯码数据...';
		  this.addTraceCodeUploadDetail('正在上传发药明细追溯码数据...', 'info');
		
		  const traceCodes = this.getCollectedTraceCodes();
		  if (traceCodes.length === 0) {
		    this.addTraceCodeUploadDetail('没有追溯码需要上传', 'info');
		    this.traceCodeUploadSteps[2].description = '无需上传追溯码';
		    this.msfxUploadSuccess = true;
		    setTimeout(() => this.checkTraceCodeUploadStep4(), 500);
		    return;
		  }
		
		  const bizNum = this.getBizNum();
		  if (!bizNum) {
		    this.addTraceCodeUploadDetail('获取业务单据编号失败', 'error');
		    this.traceCodeUploadSteps[2].description = '获取业务单据编号失败';
		    this.traceCodeHasError = true;
		    this.msfxUploadSuccess = false;
		    setTimeout(() => this.checkTraceCodeUploadStep4(), 500);
		    return;
		  }
		
		  const params = {
		    billType: 321,
		    bizNum: bizNum,
		    traceCodes: traceCodes.join(',')
		  };
		
		  this.addTraceCodeUploadDetail(`准备上传追溯码，数量: ${traceCodes.length}，业务单号: ${bizNum}`, 'info');
		  console.log('上传参数:', params);
		
		  try {
		    this.msfxUploading = true;
		    const response = await msfxUploadRetail(params);
		    console.log('msfxUploadRetail接口返回:', response);
		
		    if (response.code === 200) {
		      this.addTraceCodeUploadDetail('追溯码上传成功', 'success');
		      this.traceCodeUploadSteps[2].description = '追溯码上传成功';
		      this.msfxUploadSuccess = true;
		    } else {
		      this.addTraceCodeUploadDetail(`追溯码上传失败: ${response.message || '未知错误'}`, 'error');
		      this.traceCodeUploadSteps[2].description = '追溯码上传失败';
		      this.traceCodeHasError = true;
		      this.msfxUploadSuccess = false;
		    }
		  } catch (error) {
		    console.error('上传追溯码失败:', error);
		    this.addTraceCodeUploadDetail('上传失败: ' + (error.message || '未知错误'), 'error');
		    this.traceCodeUploadSteps[2].description = '上传失败';
		    this.traceCodeHasError = true;
		    this.msfxUploadSuccess = false;
		  } finally {
		    this.msfxUploading = false;
		  }
		
		  setTimeout(() => this.checkTraceCodeUploadStep4(), 1000);
		},
		
		async uploadTraceCodesToMsfx(traceCodes) {
		  try {
		    this.msfxUploading = true;
		    this.msfxUploadSuccess = false; // 重置上传成功标志
		    
		    // 获取业务单据编号
		    const bizNum = this.getBizNum();
		    if (!bizNum) {
		      this.addTraceCodeUploadDetail('获取业务单据编号失败', 'error');
		      this.traceCodeUploadSteps[2].description = '获取业务单据编号失败';
		      this.traceCodeHasError = true;
		      this.msfxUploading = false;
		      return false;
		    }
		    
		    // 准备上传参数
		    const params = {
		      billType: 321, // 单据类型:321
		      bizNum: bizNum, // 业务单据编号
		      traceCodes: traceCodes.join(',') // 已录入的追溯码，用逗号拼接
		    };
		    
		    this.addTraceCodeUploadDetail(`准备上传追溯码，数量: ${traceCodes.length}，业务单号: ${bizNum}`, 'info');
		    console.log('上传参数:', params);
		    
		    // 调用msfxUploadRetail接口
		    const response = await msfxUploadRetail(params);
		    console.log('msfxUploadRetail接口返回:', response);
		    
		    if (response.code === 200) {
		      this.addTraceCodeUploadDetail('追溯码上传成功', 'success');
		      this.traceCodeUploadSteps[2].description = '追溯码上传成功';
		      this.msfxUploadSuccess = true; // 标记上传成功
		      this.uploadRetryCount = 0;
		      
		      // 返回成功
		      return true;
		    } else {
		      // 上传失败，但继续发药流程
		      this.addTraceCodeUploadDetail(`追溯码上传失败: ${response.message || '未知错误'}`, 'error');
		      this.traceCodeUploadSteps[2].description = '追溯码上传失败';
		      this.traceCodeHasError = true;
		      this.msfxUploadSuccess = false;
		      
		      // 返回失败，但不会阻止流程
		      return false;
		    }
		    
		  } catch (error) {
		    console.error('上传追溯码失败:', error);
		    this.addTraceCodeUploadDetail('上传失败: ' + (error.message || '未知错误'), 'error');
		    this.traceCodeUploadSteps[2].description = '上传失败: ' + error.message;
		    this.traceCodeHasError = true;
		    this.msfxUploadSuccess = false;
		    
		    // 即使上传失败，也继续发药流程
		    return false;
		  } finally {
		    this.msfxUploading = false;
		  }
		},
		
		// 重新补传
		async retryMsfxUpload() {
		  this.showRetryButton = false;
		  this.msfxUploading = true;
		  this.uploadRetryCount++;
		  
		  this.addTraceCodeUploadDetail(`第 ${this.uploadRetryCount} 次重新补传...`, 'info');
		  
		  // 重新获取追溯码
		  const traceCodes = this.getCollectedTraceCodes();
		  
		  if (traceCodes.length === 0) {
		    this.addTraceCodeUploadDetail('没有需要上传的追溯码', 'warning');
		    this.traceCodeUploadSteps[2].description = '无需上传追溯码';
		    this.msfxUploading = false;
		    this.checkTraceCodeUploadStep4();
		    return;
		  }
		  
		  // 重新上传
		  const uploadResult = await this.uploadTraceCodesToMsfx(traceCodes);
		  
		  if (uploadResult) {
		    // 上传成功，进入下一步
		    this.checkTraceCodeUploadStep4();
		  } else {
		    // 上传失败，显示重新补传按钮
		    this.showRetryButton = true;
		  }
		},
		
		// 步骤4：完成上传
		async checkTraceCodeUploadStep4() {
		  this.traceCodeUploadStep = 3;
		  this.traceCodeUploadSteps[3].description = '追溯码发药已上传至码上放心平台。';
		  this.addTraceCodeUploadDetail('追溯码发药已上传至码上放心平台。', 'success');
		  
		  // 短暂延迟后进入下一步
		  setTimeout(() => {
		    this.checkTraceCodeUploadStep5();
		  }, 1000);
		},
		
		// 步骤5：完成发药
		async checkTraceCodeUploadStep5() {
		  // 防止重复执行
		  if (this.step5Executed) {
		    console.log('步骤5已执行，跳过重复执行');
		    return;
		  }
		  
		  this.step5Executed = true;
		  this.traceCodeUploadStep = 4;
		  this.traceCodeUploadSteps[4].description = '已完成发药。';
		  this.addTraceCodeUploadDetail('正在执行发药操作...', 'info');
		  
		  try {
		    // 准备发药数据
		    const sendData = this.prepareSendMedicineData();
		    console.log('发药数据:', JSON.stringify(sendData, null, 2));
		    
		    // 调用发药接口
		    this.addTraceCodeUploadDetail('开始调用发药接口...', 'info');
		    const res = await fySave(sendData);
		    
		    if (res.code === 200) {
		      this.addTraceCodeUploadDetail('发药成功', 'success');
		      this.dispenseSuccess = true; // 标记发药成功
		      
		      // 检查是否所有步骤都成功
		      if (this.msfxUploadSuccess) {
		        // 上传成功，自动关闭模态框并提示
		        this.addTraceCodeUploadDetail('所有步骤已完成，3秒后自动关闭...', 'success');
		        
		        // 设置自动关闭计时器
		        this.autoCloseTimer = setTimeout(() => {
		          this.closeProgressDialog();
		          this.$message.success('发药成功！');
		        }, 3000);
		      } else {
		        // 上传失败，不自动关闭模态框
		        this.addTraceCodeUploadDetail('发药成功，但追溯码上传失败，请手动关闭', 'warning');
		        this.showRetryButton = true; // 显示重新补传按钮
		      }
		    } else {
		      throw new Error(res.message || '发药失败');
		    }
		    
		  } catch (error) {
		    console.error('发药失败:', error);
		    this.addTraceCodeUploadDetail('发药失败: ' + error.message, 'error');
		    this.showRetryButton = true;
		    this.traceCodeHasError = true;
		    this.dispenseSuccess = false; // 发药失败
		  }
		},
		
		// 修改：统一的进度对话框关闭方法
		closeProgressDialog() {
		  // 清除自动关闭计时器
		  if (this.autoCloseTimer) {
		    clearTimeout(this.autoCloseTimer);
		    this.autoCloseTimer = null;
		  }
		  
		  // 如果发药成功，刷新selectPatientInfo接口数据
		  if (this.dispenseSuccess) {
		    this.addTraceCodeUploadDetail('正在刷新患者数据...', 'info');
		    
		    // 调用loadData刷新左侧表格数据
		    this.loadData();
		    
		    // 重置表单和表格数据
		    this.resetFormAndTableData();
		    
		    this.addTraceCodeUploadDetail('数据刷新完成', 'success');
		  }
		  
		  // 关闭模态框
		  this.traceCodeUploadDialog = false;
		  
		  // 重置状态
		  this.resetUploadState();
		  this.dispenseSuccess = false;
		  
		  // 如果是从发药对话框过来的，也关闭发药对话框
		  if (this.sendMedicineDialogVisible) {
		    this.sendMedicineDialogVisible = false;
		  }
		  
		  // 重置追溯码对话框相关数据
		  this.scannedMedicineList = [];
		  this.getSomeWareResult = null;
		  this.scanInput = '';
		},
		
		// 新增：重置表单和表格数据
		resetFormAndTableData() {
		  // 保存当前分页信息
		  const currentPageNum = this.leftPageNum;
		  const currentPageSize = this.leftPageSize;
		  
		  // 重置表单搜索条件
		  this.form = {
		    pharmacyName: '西药房',
		    healthId: '',
		    prescriptionSearch: '',
		    name: '',
		    refreshTime: '5',
		    showBatch: true
		  };
		  
		  // 重置右侧表单和表格
		  this.rightForm = {
		    "age": 0,
		    "agnterCretno": "",
		    "agnterName": "",
		    "cardId": "",
		    "deptName": "",
		    "fullName": "",
		    "westernDiagnos": "",
		    "id": 0,
		    "name": "",
		    "patientId": 0,
		    "remark": "",
		    "rxName": "",
		    "rxNo": 0,
		    "saleAmt": 0,
		    "sex": 0,
		    "skintstRx": 0,
		    "state": 0,
		    "voList": []
		  };
		  
		  this.rightTableData = [];
		  this.westernMedicines = [];
		  
		  // 重置发药对话框数据
		  this.sendMedicineData = {
		    patientName: '',
		    diagnosis: '',
		    traceCodeCount: 0,
		    medicineCount: 0,
		    printTogether: false
		  };
		  
		  // 重新加载数据，保持分页
		  this.leftPageNum = currentPageNum;
		  this.leftPageSize = currentPageSize;
		  this.loadData();
		  
		  console.log('表单和表格数据已重置');
		},
		
		// 重置表单
		resetForm() {
		  // 清空右侧表格
		  this.rightTableData = [];
		  this.westernMedicines = [];
		  this.scannedMedicineList = [];
		  
		  // 清空发药数据
		  this.sendMedicineData = {
		    medicineCount: 0,
		    traceCodeCount: 0,
		    printTogether: false
		  };
		  
		  // 清空选择的患者
		  this.selectedData = [];
		  this.rightForm = {};
		  
		  // 清空追溯码对话框
		  this.scannedMedicineList = [];
		  this.getSomeWareResult = null;
		  this.scanInput = '';
		  this.traceCodeDialogVisible = false;
		  
		  console.log('表单已重置');
		},
		
		// 刷新患者数据
		refreshPatientData() {
		  // 尝试调用不同的刷新方法
		  if (typeof this.loadData === 'function') {
		    this.loadData();
		  } else if (typeof this.getPatientList === 'function') {
		    this.getPatientList();
		  } else if (typeof this.getList === 'function') {
		    this.getList();
		  } else if (typeof this.$parent.loadData === 'function') {
		    this.$parent.loadData();
		  } else if (typeof this.$parent.getPatientList === 'function') {
		    this.$parent.getPatientList();
		  } else {
		    // 如果没有刷新方法，可以触发一个事件或直接调用接口
		    console.log('尝试刷新患者数据');
		    this.loadPatientDataFromApi();
		  }
		},
		
		// 从API加载患者数据
		loadPatientDataFromApi() {
		  // 这里应该调用获取患者数据的接口
		  // 例如：getPatientList().then(res => {...})
		  console.log('调用接口刷新患者数据');
		  // 实际代码中这里应该调用具体的API接口
		},
		
		// 准备发药数据
		prepareSendMedicineData() {
		  let tracCodeJson = [];
		  this.rightTableData.forEach(item => {
		    if (item.isBar === 1 && item.drgTracCode) {
		      let chgCnt;
		      if (item.saleUnt === 1 && item.editedPacCnt) {
		        chgCnt = item.editedPacCnt;
		      } else {
		        chgCnt = item.pacCnt || 1;
		      }
		      // 关键修改：增加 manuLotnum 字段，取值为药品行的生产批号
		      tracCodeJson.push({
		        barcode: item.drgTracCode,
		        chgCnt: chgCnt,
		        manuLotnum: item.manuLotnum || ''   // 新增：生产批号
		      });
		    }
		  });
		
		  return {
		    id: this.rightForm.id,
		    voList: this.rightTableData.map(item => ({
		      id: item.id || item.rdDetailsId,
		      drgTracCnt: Number(item.drgTracCnt) || 0,
		      drgTracCode: item.drgTracCode || '',
		      drugTracB: Number(item.drugTracB) || 0,
		      drugTracMaxCnt: Number(item.drugTracMaxCnt) || 0,
		      drugTracMaxId: Number(item.drugTracMaxId) || 0,
		      drugTracMinId: Number(item.drugTracMinId) || 0,
		      cnt: Number(item.cnt) || 0,
		      purcPric: Number(item.purcPric) || 0,
		      saleAmt: Number(item.saleAmt) || 0,
		      isBar: item.isBar || 0,
		      tracCodeJson: tracCodeJson.length > 0 ? JSON.stringify(tracCodeJson) : '',
		      pacCnt: item.pacCnt || 1
		    }))
		  };
		},
		
		// 获取已采集的追溯码
		getCollectedTraceCodes() {
		  const traceCodes = [];
		  this.rightTableData.forEach(item => {
		    if (item.isBar === 1 && item.drgTracCode && item.drgTracCode.trim() !== '') {
		      traceCodes.push(item.drgTracCode.trim());
		    }
		  });
		  return traceCodes;
		},
		
		// 获取强制追溯码药品数量
		getMandatoryTraceDrugsCount() {
		  return this.rightTableData.filter(item => item.isBar === 1).length;
		},
		
		// 检查是否有强制追溯码药品
		hasMandatoryTraceDrugs() {
		  return this.rightTableData.some(item => item.isBar === 1);
		},
		
		// 获取业务单据编号
		getBizNum() {
		  // 从selectPatientInfo接口下voList中的rxNo获取
		  // 这里需要根据实际数据结构调整
		  if (this.rightForm && this.rightForm.rxNo) {
		    return this.rightForm.rxNo;
		  }
		  
		  // 如果没有rxNo，尝试从其他位置获取
		  console.warn('未找到业务单据编号，使用默认值');
		  return this.rightForm.id || '';
		},
		
		// 获取步骤状态
		getStepStatus(index) {
		  // 如果当前步骤是第三步且上传失败，显示错误
		  if (this.traceCodeHasError && index === 2) {
		    return 'error';
		  }
		  
		  // 如果当前步骤小于当前步骤索引，显示完成
		  if (index < this.traceCodeUploadStep) {
		    return 'success';
		  } 
		  // 如果当前步骤等于当前步骤索引，显示进行中
		  else if (index === this.traceCodeUploadStep) {
		    return 'process';
		  } 
		  // 否则显示等待
		  else {
		    return 'wait';
		  }
		},
		
		// 添加步骤详情
		addTraceCodeUploadDetail(message, type = 'info') {
		  this.traceCodeUploadDetails.push({
		    message,
		    type,
		    time: new Date().toLocaleTimeString()
		  });
		  
		  // 自动滚动到底部
		  this.$nextTick(() => {
		    const container = this.$refs.uploadDetailsContainer;
		    if (container) {
		      container.scrollTop = container.scrollHeight;
		    }
		  });
		},
		
		// 新增：处理进度对话框关闭前的事件
		handleProgressDialogBeforeClose(done) {
		  if (this.traceCodeUploadStep < 4 || this.traceCodeHasError) {
		    // 如果流程未完成或有错误，询问用户
		    this.$confirm('确定要关闭进度对话框吗？关闭后当前进度将丢失。', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning'
		    }).then(() => {
		      this.addTraceCodeUploadDetail('用户手动关闭了进度对话框', 'warning');
		      this.closeProgressDialog();
		      done();
		    }).catch(() => {
		      // 用户取消关闭
		    });
		  } else {
		    // 流程已完成，直接关闭
		    this.closeProgressDialog();
		    done();
		  }
		},
		
		// 处理发药数量变化
		handleCntChange(row) {
		  const pacCnt = parseInt(row.pacCnt) || 1;
		  const cnt = parseInt(row.cnt) || 1;
		  
		  if (cnt > pacCnt) {
		    this.$message.warning(`发药数量不能超过包装数量 ${pacCnt}`);
		    row.cnt = pacCnt;
		  }
		  
		  if (cnt <= 0) {
		    row.cnt = 1;
		  }
		},
		
		// 验证发药数量输入
		validateCntInput(row) {
		  const pacCnt = parseInt(row.pacCnt) || 1;
		  const cnt = parseInt(row.cnt) || 1;
		  
		  if (cnt > pacCnt) {
		    this.$message.warning(`发药数量不能超过包装数量 ${pacCnt}`);
		    row.cnt = pacCnt;
		  }
		  
		  if (cnt <= 0) {
		    row.cnt = 1;
		  }
		},
		
		// 处理包装数量输入
		handlePacCntInput(row) {
		  console.log('包装数量输入:', row.pacCnt);
		  
		  // 确保输入的是数字
		  if (typeof row.pacCnt === 'string') {
		    // 移除非数字字符
		    row.pacCnt = row.pacCnt.replace(/[^0-9]/g, '');
		  }
		  
		  // 转换为数字
		  const pacCnt = parseInt(row.pacCnt) || 0;
		  const originalPacCnt = parseInt(row.originalPacCnt) || 1;
		  
		  // 验证包装数量
		  this.validateSinglePacCnt(row, pacCnt, originalPacCnt);
		  
		  // 更新确定按钮状态
		  this.updateConfirmButtonState();
		},
		
		// 验证单个药品的包装数量
		validateSinglePacCnt(row, pacCnt, originalPacCnt) {
		  if (pacCnt < 1) {
		    row.pacCntValid = false;
		    row.pacCntError = '包装数量不能小于1';
		    return false;
		  }
		  
		  if (pacCnt > originalPacCnt) {
		    row.pacCntValid = false;
		    row.pacCntError = `包装数量不能大于原始包装数量 ${originalPacCnt}`;
		    return false;
		  }
		  
		  // 验证是否为整数
		  if (!Number.isInteger(pacCnt)) {
		    row.pacCntValid = false;
		    row.pacCntError = '包装数量必须为整数';
		    return false;
		  }
		  
		  // 验证不能包含中文
		  const pacCntStr = String(pacCnt);
		  const chineseRegex = /[\u4e00-\u9fa5]/;
		  if (chineseRegex.test(pacCntStr)) {
		    row.pacCntValid = false;
		    row.pacCntError = '包装数量不能包含中文';
		    return false;
		  }
		  
		  row.pacCntValid = true;
		  row.pacCntError = '';
		  return true;
		},
		
		// 验证包装数量（失去焦点时）
		validatePacCnt(row) {
		  const pacCnt = parseInt(row.pacCnt) || 0;
		  const originalPacCnt = parseInt(row.originalPacCnt) || 1;
		  
		  const isValid = this.validateSinglePacCnt(row, pacCnt, originalPacCnt);
		  
		  if (!isValid) {
		    this.$message.warning(row.pacCntError || '包装数量校验失败');
		    
		    // 如果输入无效，重置为原始值
		    row.pacCnt = originalPacCnt;
		    row.pacCntValid = true; // 重置为有效状态
		  }
		  
		  // 更新确定按钮状态
		  this.updateConfirmButtonState();
		  
		  return isValid;
		},
		
		// 更新确定按钮状态
		updateConfirmButtonState() {
		  // 这个方法会在其他地方调用，确保确定按钮状态正确
		  this.$nextTick(() => {
		    // 确保按钮状态更新
		  });
		},
		
		// 检查是否所有包装数量都有效
		checkAllPacCntValid() {
		  if (!this.scannedMedicineList || this.scannedMedicineList.length === 0) {
		    return false;
		  }
		  
		  // 检查所有可编辑的药品
		  const editableItems = this.scannedMedicineList.filter(item => item.editable);
		  
		  if (editableItems.length === 0) {
		    return true; // 没有可编辑的药品，视为有效
		  }
		  
		  // 检查所有可编辑药品的包装数量是否有效
		  const invalidItems = editableItems.filter(item => !item.pacCntValid);
		  
		  return invalidItems.length === 0;
		},
		
		// 处理上传取消
		handleUploadCancel() {
		  this.$confirm('确定要取消上传吗？取消后发药流程将终止。', '提示', {
		    confirmButtonText: '确定',
		    cancelButtonText: '取消',
		    type: 'warning'
		  }).then(() => {
		    this.addTraceCodeUploadDetail('用户取消了发药流程', 'warning');
		    this.traceCodeUploadDialog = false;
		    this.$message.info('发药流程已取消');
		    
		    // 重置状态
		    this.resetUploadState();
		    this.dispenseSuccess = false;
		  });
		},
		
		// 关闭上传对话框
		closeUploadDialog() {
		  this.closeProgressDialog();
		},
		
		// 重置上传状态
		resetUploadState() {
		  this.traceCodeUploadStep = 0;
		  this.traceCodeUploadDetails = [];
		  this.traceCodeHasError = false;
		  this.showRetryButton = false;
		  this.uploadRetryCount = 0;
		  this.msfxUploading = false;
		  this.msfxUploadSuccess = false;
		  this.step5Executed = false;
		  this.dispenseSuccess = false;
		  this.barcodeScreenResult = null; // 新增重置
		  // 清除自动关闭计时器
		  if (this.autoCloseTimer) {
		    clearTimeout(this.autoCloseTimer);
		    this.autoCloseTimer = null;
		  }
		  
		  // 重置步骤描述
		  this.traceCodeUploadSteps = [
		    { title: '检查追溯码', description: '正在检查是否有药品需要录入追溯码...' },
		    { title: '接入码上放心', description: '正在接入码上放心平台接口...' },
		    { title: '上传追溯码', description: '正在上传发药明细追溯码数据...' },
		    { title: '完成上传', description: '追溯码发药已上传至码上放心平台。' },
		    { title: '完成发药', description: '已完成发药。' }
		  ];
		},
		
		// 发药成功后的处理
		handleSendMedicineSuccess() {
		  // 这里可以添加发药成功后的操作
		  // 比如：刷新列表、清空数据、显示成功消息等
		  
		  // 清空已选中的数据
		  this.selectedData = [];
		  this.rightTableData = [];
		  this.westernMedicines = [];
		  this.scannedMedicineList = [];
		  this.sendMedicineData.traceCodeCount = 0;
		  
		  // 重置表单搜索条件
		  this.form.healthId = '';
		  this.form.prescriptionSearch = '';
		  this.form.name = '';
		  
		  // 重置右侧表单
		  this.rightForm = {
		    "age": 0,
		    "agnterCretno": "",
		    "agnterName": "",
		    "cardId": "",
		    "deptName": "",
		    "fullName": "",
		    "westernDiagnos": "",
		    "id": 0,
		    "name": "",
		    "patientId": 0,
		    "remark": "",
		    "rxName": "",
		    "rxNo": 0,
		    "saleAmt": 0,
		    "sex": 0,
		    "skintstRx": 0,
		    "state": 0,
		    "voList": []
		  };
		  
		  console.log('发药成功，已重置表单数据');
		  
		  // 不自动刷新数据，由用户手动关闭时刷新
		  this.$message.success('发药成功');
		},
		
		// 重新补传方法
		async retryUpload() {
		  this.traceCodeUploadStep = 2;
		  this.traceCodeUploadDetails = [];
		  this.traceCodeHasError = false;
		  
		  try {
		    await this.checkTraceCodeUploadStep2();
		    await this.checkTraceCodeUploadStep3();
		    this.checkTraceCodeUploadStep4();
		  } catch (error) {
		    console.error('补传失败:', error);
		  }
		},
		
		// 将药品数据转换为追溯码表格数据
		transformToTraceCodeData(medicineList) {
		    return medicineList.map(item => {
		      return {
		        medicineName: `${item.drugName} ${item.drugSpec}`,
		        productCode: item.prodentpName || '未知厂家',
		        sendStatus: '未关联',
		        sendCombo: `${item.cnt}${item.unt}`,
		        drgTracCnt: '0',
		        drgTracCode: '',
		        rawData: item // 保留原始数据以便后续操作
		      };
		    });
		},
	
		// 完成追溯码采集
		async completeTraceCode() {
		  if (this.scannedMedicineList.length === 0) {
		    this.$message.warning('请先扫描药品追溯码');
		    return;
		  }
		
		  // 检查包装数量是否全部有效
		  if (!this.checkAllPacCntValid()) {
		    this.$message.error('存在包装数量校验不通过，请检查后重试');
		    return;
		  }
		
		  // 检查是否有验证失败的药品
		  const failedValidation = this.scannedMedicineList.some(
		    item => item.validationStatus === 'warning' || item.validationStatus === 'error'
		  );
		
		  if (failedValidation) {
		    this.$confirm(
		      '存在药品验证失败或需要维护，是否继续完成采集？',
		      '提示',
		      {
		        confirmButtonText: '继续完成',
		        cancelButtonText: '取消',
		        type: 'warning'
		      }
		    ).then(() => {
		      this.finishTraceCodeCollection();
		    }).catch(() => {
		      // 用户取消
		    });
		  } else {
		    this.finishTraceCodeCollection();
		  }
		},
		
		// 将已扫描的药品转换为追溯码表格数据
		convertScannedToTraceData() {
		  this.traceCodeTableData = this.scannedMedicineList.map((item, index) => {
		    const traceCodeCount = item.drgTracCode ? 1 : 0;
		    
		    return {
		      id: index + 1,
		      medicineName: `${item.drugName} ${item.spec || ''}`.trim(),
		      productCode: item.manufacturer || '未知厂家',
		      sendStatus: item.drgTracCode ? '已关联' : '未关联',
		      sendCombo: '1', // 默认发药组合
		      drgTracCnt: traceCodeCount,
		      drgTracCode: item.drgTracCode || '',
		      pacCnt: item.pacCnt || 1,
		      rawData: {
		        ...item.rawData,
		        drugTracB: 1, // 强制追溯码
		        drugName: item.drugName,
		        drugSpec: item.spec,
		        prodentpName: item.manufacturer,
		        manuLotnum: item.batchNo,
		        expyDate: item.expireDate
		      },
		      validationStatus: item.validationStatus
		    };
		  });
		},
		
		// 完成追溯码采集
		finishTraceCodeCollection() {
		  console.log('完成追溯码采集，已扫描的药品:', this.scannedMedicineList);
		  
		  // 1. 更新右侧表格中的追溯码信息
		  this.updateRightTableWithTraceCodes();
		  
		  // 2. 更新追溯码数量显示
		  this.updateTraceCodeCount();
		  
		  // 3. 更新 westernMedicines
		  this.updateWesternMedicines();
		  
		  console.log('更新后的 rightTableData:', this.rightTableData);
		  console.log('更新后的 sendMedicineData:', this.sendMedicineData);
		  console.log('hasUncollectedMandatoryTrace:', this.hasUncollectedMandatoryTrace);
		  console.log('isBarRequired:', this.isBarRequired);
		  console.log('sendMedicineData.traceCodeCount:', this.sendMedicineData.traceCodeCount);
		  
		  // 4. 清空已扫描列表
		  this.scannedMedicineList = [];
		  this.getSomeWareResult = null;
		  this.scanInput = '';
		  
		  // 5. 关闭追溯码对话框
		  this.traceCodeDialogVisible = false;
		  
		  // 6. 重新打开发药对话框
		  this.sendMedicineDialogVisible = true;
		  
		  this.$message.success('追溯码采集完成');
		},
		
		// 更新 westernMedicines
		updateWesternMedicines() {
		  this.westernMedicines = this.rightTableData.map(item => ({
		    ...item,
		    // 检查药品是否需要追溯码
		    isBar: item.isBar || 0,
		    // 检查是否已采集追溯码
		    traceCodeCollected: this.isMedicineTraceCodeCollected(item),
		    // 同步 editedPacCnt
		    editedPacCnt: item.editedPacCnt || null
		  }));
		},
		
		// 检查药品是否已采集追溯码
		isMedicineTraceCodeCollected(medicine) {
		  // 如果有强制追溯码标志且已录入追溯码
		  if (medicine.isBar === 1) {
		    return !!(medicine.drgTracCode && medicine.drgTracCode.trim() !== '');
		  }
		  return true; // 非强制追溯码药品直接返回true
		},
		
		// 更新右侧表格中的追溯码信息
		updateRightTableWithTraceCodes() {
		  // 遍历已扫描的药品列表
		  this.scannedMedicineList.forEach(scannedItem => {
		    // 查找右侧表格中对应的药品
		    const index = this.rightTableData.findIndex(item => 
		      item.drugName === scannedItem.drugName
		    );
		    
		    if (index !== -1) {
		      // 更新追溯码信息
		      this.$set(this.rightTableData[index], 'drgTracCode', scannedItem.traceCode);
		      this.$set(this.rightTableData[index], 'drgTracCnt', 1);
		      this.$set(this.rightTableData[index], 'traceCodeCollected', true);
		      this.$set(this.rightTableData[index], 'isBar', 1); // 标记为需要追溯码
		      
		      // 关键修改：保存生产批号
		      if (scannedItem.batchNo) {
		        this.$set(this.rightTableData[index], 'manuLotnum', scannedItem.batchNo);
		        console.log(`保存生产批号: ${scannedItem.batchNo} (药品: ${scannedItem.drugName})`);
		      }
		      
		      // 关键修改：保存用户编辑后的包装数量（仅当 saleUnt === 1 时才有意义）
		      if (scannedItem.saleUnt === 1) {
		        this.$set(this.rightTableData[index], 'editedPacCnt', scannedItem.pacCnt);
		        console.log(`保存用户编辑后的包装数量: ${scannedItem.pacCnt} (药品: ${scannedItem.drugName})`);
		      }
		      
		      // 如果有wareData，更新更多信息
		      if (scannedItem.wareData) {
		        this.$set(this.rightTableData[index], 'wareData', scannedItem.wareData);
		      }
		      
		      // 更新原始数据
		      if (scannedItem.rawData) {
		        this.$set(this.rightTableData[index], 'rawTraceCodeData', scannedItem.rawData);
		      }
		    } else {
		      // 如果在右侧表格中没找到，可能是新添加的药品
		      console.log('未找到对应药品:', scannedItem.drugName);
		    }
		  });
		  
		  // 更新westernMedicines
		  this.updateWesternMedicines();
		},
		
		// 跳转到药品维护页面
		goToDrugMaintenance() {
		  if (!this.getSomeWareResult || !this.scannedMedicineList.length > 0) {
		    this.$message.warning('没有药品信息可以维护');
		    return;
		  }
		  
		  // 获取最近扫描的药品信息
		  const lastMedicine = this.scannedMedicineList[this.scannedMedicineList.length - 1];
		  
		  if (!lastMedicine || !lastMedicine.rawData) {
		    this.$message.warning('药品信息不完整');
		    return;
		  }
		  
		  // 准备传递的数据
		  const drugData = {
		    drugName: lastMedicine.drugName,
		    spec: lastMedicine.spec,
		    pacCnt: lastMedicine.pacCnt,
		    manufacturer: lastMedicine.manufacturer,
		    traceCode: lastMedicine.traceCode,
		    rawData: lastMedicine.rawData
		  };
		  
		  console.log('跳转到药品维护，携带数据:', drugData);
		  
		  // 使用query参数传递数据
		  this.$router.push({
		    path: '/Western',
		    query: {
		      action: 'add',
		      drugData: JSON.stringify(drugData)
		    }
		  });
		  
		  // 关闭追溯码对话框
		  this.traceCodeDialogVisible = false;
		},
		
		// 打印收据
		async printReceipt() {
		  try {
			// 调用打印接口
			await this.$print.executePrint();
			this.$message.success('打印成功');
		  } catch (error) {
			console.error('打印失败:', error);
			this.$message.error('打印失败');
		  }
		},
		
		// 关闭对话框处理
		handleSendMedicineClose(done) {
		  this.$confirm('确认取消发药？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		  }).then(() => {
			done();
			this.$message.info('已取消发药');
		  }).catch(() => {});
		},
		
		// 修改追溯码关闭方法
		handleTraceCodeClose() {
		  console.log('关闭追溯码对话框');
		  this.traceCodeDialogVisible = false;
		  this.scanInput = '';
		  this.getSomeWareResult = null;
		  
		  // 不自动打开发药对话框，由用户决定
		  // this.sendMedicineDialogVisible = true;
		},
		
		// 追溯码对话框关闭前的处理
		handleTraceCodeBeforeClose(done) {
		  if (this.scannedMedicineList.length > 0) {
		    this.$confirm('关闭后已扫描的药品信息将丢失，确定要关闭吗？', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning'
		    }).then(() => {
		      // 清空已扫描的药品
		      this.scannedMedicineList = [];
		      this.getSomeWareResult = null;
		      this.scanInput = '';
		      done();
		    }).catch(() => {
		      // 用户取消关闭
		    });
		  } else {
		    this.scanInput = '';
		    this.getSomeWareResult = null;
		    done();
		  }
		},
		
		setAllButtonsLoading(isLoading) {
		    this.loading = isLoading;
		    // 设置所有按钮的加载状态
		    for (let key in this.buttonLoading) {
		      this.buttonLoading[key] = isLoading;
		    }
		  },
		  
		// 格式化货币金额
		formatCurrency(value) {
		  if (value === null || value === undefined || value === '') {
		    return '￥0';
		  }
		  
		  const num = Number(value);
		  if (isNaN(num)) {
		    return '￥0';
		  }
		  
		  return `￥${num}`;
		},
		
		// 获取状态文本
		getStatusText(state) {
		  return this.statusMap[state] || '未知状态';
		},
		
		// 获取状态标签类型
		getStatusType(state) {
		  switch(state) {
			case 0: return 'info';
			case 1: return 'primary';
			case 2: return 'warning';
			case 3: return 'success';
			case 4: return 'danger';
			default: return 'info';
		  }
		},
		
		// 添加合计行计算方法
	    getSummaries(param) {
	      const { columns, data } = param;
	      const sums = [];
	      
	      columns.forEach((column, index) => {
	        if (index === 0) {
	          sums[index] = '合计';
	          return;
	        }
	        
	        // 只对金额和数量列进行合计
	        if (column.property === 'purcPric' || column.property === 'cnt' || column.property === 'saleAmt') {
	          const values = data.map(item => {
	            // 确保数据是数字类型
	            const value = Number(item[column.property]);
	            return isNaN(value) ? 0 : value;
	          });
	          
	          // 计算合计值
	          const sum = values.reduce((prev, curr) => prev + curr, 0);
	          
	          // 金额保留2位小数
	          sums[index] = column.property === 'purcPric' || column.property === 'saleAmt' ? sum: sum;
	        } else {
	          sums[index] = '';
	        }
	      });
	    
	      return sums;
	    },
	    
	    calculateTableHeights() {
	      // 计算左侧表格高度
	      const leftFormHeight = document.querySelector('.left-form')?.offsetHeight || 200;
	      const leftPaginationHeight = 40; // 分页组件高度
	      const leftTableHeight = window.innerHeight - 50 - 50 - leftFormHeight - leftPaginationHeight - 30; // 减去header、bottom、form、分页高度以及padding
	      this.leftTableHeight = Math.max(200, leftTableHeight) + 'px';
	      
	      // 计算右侧表格高度
	      const rightDescriptionsHeight = document.querySelector('.right-descriptions')?.offsetHeight || 200;
	      const rightTableHeight = window.innerHeight - 50 - 50 - rightDescriptionsHeight - 30; // 减去header、bottom、描述列表高度以及padding
	      this.rightTableHeight = Math.max(200, rightTableHeight) + 'px';
	    }
	  }
	}
	</script>
	
	<style lang="less" scoped>
		/* 添加合计行样式 */
		/deep/ .el-table__footer-wrapper .el-table__footer .cell {
		  font-weight: bold;
		  color: #aa0000;
		}
		
		/* 完成发药对话框样式 */
		.send-medicine-dialog /deep/ .el-dialog__header {
		  border-bottom: 1px solid #e8e8e8;
		  padding: 16px 20px;
		}
		
		/deep/ .el-link{
			justify-content:left;
		}
		.send-medicine-dialog /deep/ .el-dialog__body {
		  padding: 20px;
		}
		
		.send-medicine-content {
		  border: 1px solid #dcdfe6;
		  border-radius: 4px;
		  padding: 16px;
		  .medicine-list {
			max-height: 0;
			overflow: hidden;
			transition: max-height 0.3s ease;
			
			&.expanded {
			  max-height: 500px; /* 根据实际内容高度调整 */
			}
		  }
		}
		
		.info-item {
		  display: flex;
		  margin-bottom: 12px;
		  align-items: flex-start;
		}
		
		.info-item:last-child {
		  margin-bottom: 0;
		}
		
		.label {
		  width: 80px;
		  color: #606266;
		  font-weight: 500;
		}
		
		.value {
		  flex: 1;
		  color: #303133;
		}
		
		.medicine-content {
		  display: flex;
		  flex-direction: column;
		  gap: 8px;
		}
		
		.trace-code-link {
		  font-size: 14px;
		}
		
		.medicine-type {
		  color: #606266;
		  font-size: 14px;
		}
		
		.dialog-footer {
		  display: flex;
		  justify-content: space-between;
		  align-items: center;
		  margin-top: 20px;
		  padding-top: 16px;
		  border-top: 1px solid #e8e8e8;
		}
		
		.footer-buttons {
		  display: flex;
		  gap: 12px;
		}
		
		/* 追溯码采集对话框样式 */
		.trace-code-dialog /deep/ .el-dialog__body {
		  padding: 20px;
		}
		
		.important-reminder {
		  background: #fff6e6;
		  border: 1px solid #ffd591;
		  border-radius: 4px;
		  padding: 12px;
		  margin-bottom: 16px;
		}
		
		.reminder-header {
		  display: flex;
		  align-items: center;
		  margin-bottom: 8px;
		  color: #d46b08;
		  font-weight: 500;
		}
		
		.reminder-header i {
		  margin-right: 8px;
		}
		
		.reminder-content p {
		  margin: 4px 0;
		  color: #d46b08;
		  font-size: 13px;
		  line-height: 1.5;
		}
		
		.scan-input-area {
		  margin-bottom: 16px;
		}
		
		.trace-code-input {
		  margin-bottom: 8px;
		}
		
		.input-tips {
		  display: flex;
		  gap: 16px;
		  font-size: 13px;
		}
		
		.trace-code-table /deep/ .el-table__cell {
		  padding: 8px 0;
		}
		
		.no-trace-code {
		  color: #909399;
		  font-style: italic;
		}
		
		.trace-code-footer {
		  display: flex;
		  justify-content: flex-end;
		  gap: 12px;
		}
		
		/* 右侧描述列表样式 */
		.right-descriptions {
		  padding: 10px;
		  border-bottom: 1px solid #e6e6e6;
		  overflow-y: auto;
		  flex-shrink: 0;
		  
		  .custom-descriptions {
			font-size: 12px !important;
			
			/deep/ .el-descriptions__label {
			  font-weight: 500;
			  color: #606266;
			}
			
			/deep/ .el-descriptions__content {
			  color: #303133;
			}
			
			.remark-text {
			  color: #909399;
			  font-style: italic;
			}
		  }
		}
		
		.send-medici-container {
		  width: 100%;
		  height: calc(100vh - 120px);
		  padding: 12px;
		  display: flex;
		  flex-direction: column;
		  background-color: #f5f5f5;
		  overflow: hidden;
		  
		  .send-medici-header {
			height: 50px;
			background-color: #409EFF;
			color: white;
			display: flex;
			align-items: center;
			padding: 0 20px;
			flex-shrink: 0;
			
			h4 {
			  margin: 0;
			  font-size: 16px;
			  font-weight: normal;
			}
		  }
		  
		  .send-medici-main {
			flex: 1;
			display: flex;
			overflow: hidden;
			
			.send-medici-left {
			  width: 20%;
			  height: 100%;
			  display: flex;
			  flex-direction: column;
			  border-right: 1px solid #e6e6e6;
			  background-color: white;
			  overflow: hidden;
			  
			  .left-form {
				padding: 10px;
				border-bottom: 1px solid #e6e6e6;
				overflow-y: auto;
				flex-shrink: 0;
				
				.el-form-item {
				  margin-bottom: 10px;
				  
				  .form-item-row {
					display: flex;
					align-items: center;
					width: 100%;
					
					.form-label {
					  width: 58px;
					  text-align: left;
					  padding-right: 10px;
					  color: #606266;
					  font-size: 12px;
					}
					
					.el-select, .el-input {
					  flex: 1;
					  min-width: 88px;
					}
					
					.el-button {
					  padding: 6px 8px;
					  min-width: 36px;
					}
				  }
				}
			  }
			  
			  .left-table-container {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				
				.left-table {
				  flex: 1;
				  overflow: auto;
				}
				
				.left-pagination {
				  padding: 10px;
				  border-top: 1px solid #e6e6e6;
				  background-color: #fff;
				  flex-shrink: 0;
				  
				  /deep/ .el-pagination {
					justify-content: center;
				  }
				}
			  }
			}
			
			.send-medici-right {
			  width: 80%;
			  height: 100%;
			  display: flex;
			  flex-direction: column;
			  background-color: white;
			  overflow: hidden;
			  
			  .right-table-container {
				flex: 1;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				padding: 10px;
				
				.right-table {
				  flex: 1;
				  overflow: auto;
				  
				  /deep/ .el-table__body-wrapper {
					overflow-x: auto;
					overflow-y: auto;
				  }
				}
			  }
			}
		  }
		  
		  .send-medici-bottom {
			height: 50px;
			background-color: white;
			border-top: 1px solid #e6e6e6;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 20px;
			flex-shrink: 0;
			
			.bottom-left, .bottom-right {
			  display: flex;
			  align-items: center;
			}
			
			.el-button[disabled] {
			  opacity: 0.6;
			}
		  }
		}
	</style>

<style lang="less" scoped>
/* 追溯码采集对话框样式 */
.trace-code-collect-dialog {
  /deep/ .el-dialog__header {
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
  }
  
  /deep/ .el-dialog__body {
    padding: 8px !important; /* 设置内边距为8px */
  }
  
  .trace-code-dialog-content {
    .scanned-medicine-list-section {
      margin-top: 12px;
      border: 1px solid #e6e6e6;
      border-radius: 4px;
      padding: 12px;
      background-color: #fff;
      
      .scanned-table-container {
        height: 400px; /* 固定容器高度 */
        overflow: hidden; /* 隐藏容器溢出 */
        
        .scanned-medicine-table {
          height: 100% !important; /* 表格高度100%填充容器 */
          
          /deep/ .el-table__body-wrapper {
            overflow-y: auto !important; /* 只在表格内容中显示滚动条 */
            overflow-x: auto !important;
            height: calc(100% - 40px); /* 减去表头高度 */
          }
          
          /deep/ .el-table__fixed-body-wrapper {
            overflow-y: auto !important;
          }
          
          /deep/ .el-table__fixed-right .el-table__fixed-body-wrapper {
            overflow-y: auto !important;
          }
        }
      }
      
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        
        h4 {
          margin: 0;
          color: #303133;
          font-size: 14px;
          font-weight: 500;
        }
      }
      
      .scanned-summary {
        text-align: right;
        font-size: 13px;
        color: #606266;
        padding-top: 8px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
      }
    }
    
    .important-reminder {
      background: #f0f9ff;
      border: 1px solid #91d5ff;
      border-radius: 4px;
      padding: 8px 12px;
      margin-bottom: 12px;
      
      .reminder-header {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        color: #1890ff;
        font-weight: 500;
        
        i {
          margin-right: 8px;
        }
      }
      
      .reminder-content p {
        margin: 2px 0;
        color: #1890ff;
        font-size: 12px;
        line-height: 1.4;
      }
    }
    
    .scan-input-area {
      margin-bottom: 12px;
      
      .trace-code-input {
        margin-bottom: 8px;
      }
      
      .input-tips {
        display: flex;
        gap: 12px;
        font-size: 12px;
        color: #909399;
        
        span {
          display: flex;
          align-items: center;
          
          i {
            margin-right: 4px;
          }
        }
      }
    }
    
    .validation-result {
      margin-bottom: 12px;
    }
    
    .empty-scanned-list {
      border: 1px dashed #dcdfe6;
      border-radius: 4px;
      padding: 30px 20px;
      text-align: center;
      background-color: #fafafa;
      margin-top: 12px;
      
      .empty-content {
        color: #909399;
      }
    }
  }
  
  .trace-code-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 8px 16px;
  }
}

/* 已扫描药品表格的tooltip样式 */
.el-tooltip__popper {
  max-width: 300px;
  word-break: break-all;
  white-space: normal;
}

/* 追溯码表格中的省略号样式 */
.scanned-medicine-table {
  /deep/ .el-table__cell {
    padding: 4px 0;
    
    .cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

/* 系统提示模态框样式 */
.system-prompt-dialog /deep/ .el-dialog__body {
  padding: 20px;
}

.system-prompt-message {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f0f9ff;
  border-radius: 4px;
  border-left: 4px solid #409EFF;
}

.system-prompt-table {
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}

.system-prompt-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

</style>